import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.post.list');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-post-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.post.list/view.scss */
:host {
  display: block;
  min-height: 100%;
  height: 100%;
}

.schedule-page {
  --schedule-card-radius: 20px;
  --schedule-inner-radius: 14px;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  padding: 32px 36px;
  color: #0f172a;
  background: radial-gradient(circle at 8% 4%, rgba(124, 58, 237, 0.1), transparent 28%), radial-gradient(circle at 92% 10%, rgba(225, 29, 72, 0.08), transparent 24%), linear-gradient(180deg, #fbf9ff 0%, #f7f4fb 100%);
}

.schedule-page *,
.schedule-page *::before,
.schedule-page *::after,
.schedule-modal-backdrop *,
.schedule-modal-backdrop *::before,
.schedule-modal-backdrop *::after {
  box-sizing: border-box;
}

.schedule-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  max-width: 1220px;
  margin-right: auto;
  margin-bottom: 24px;
  margin-left: auto;
}

.schedule-title {
  min-width: 0;
  width: 100%;
}

.schedule-title .eyebrow {
  margin: 0 0 10px;
  color: #e11d48;
  font-size: 12px;
  font-weight: 800;
}

.schedule-title h1 {
  margin: 0;
  color: #0f172a;
  font-size: clamp(25px, 2.2vw, 31px);
  font-weight: 900;
  letter-spacing: -0.04em;
}

.schedule-summary {
  min-width: 0;
  margin: 10px 0 0;
  color: #64748b;
  font-size: 14px;
}

.schedule-month-control svg,
.day-add-button svg,
.side-panel-close svg,
.modal-close svg {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}

.schedule-content {
  display: flex;
  width: 100%;
  max-width: 1220px;
  min-height: 0;
  flex-direction: column;
  gap: 14px;
  margin-right: auto;
  margin-left: auto;
}

.schedule-calendar,
.schedule-side-panel {
  border: 1px solid rgba(255, 255, 255, 0.88);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(253, 251, 255, 0.86));
  box-shadow: 0 20px 50px rgba(63, 42, 92, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px);
}

.calendar-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 7px 18px;
  min-height: 72px;
  padding: 18px 20px 14px;
  background: linear-gradient(180deg, rgba(250, 248, 255, 0.76), rgba(255, 255, 255, 0.24));
}

.schedule-month-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.month-navigation {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.month-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  color: #7c3aed;
  background: transparent;
  cursor: pointer;
  transition: background-color 160ms ease, transform 160ms ease;
}

.month-arrow:hover {
  background: #ede9fe;
  transform: translateY(-1px);
}

.month-picker-wrap {
  position: relative;
  z-index: 8;
}

.month-picker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 146px;
  height: 34px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  color: #241b35;
  font: inherit;
  font-size: 14px;
  font-weight: 900;
  background: transparent;
  cursor: pointer;
  transition: color 160ms ease, box-shadow 160ms ease;
}

.month-picker:hover {
  color: #7c3aed;
}

.month-picker:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.18);
}

.month-picker-chevron {
  width: 13px !important;
  height: 13px !important;
  color: #8b5cf6;
  pointer-events: none;
  transition: transform 160ms ease;
}

.month-picker-wrap.open .month-picker-chevron {
  transform: rotate(180deg);
}

.period-picker-dropdown {
  position: absolute;
  top: calc(100% + 9px);
  left: 50%;
  z-index: 20;
  width: 276px;
  padding: 15px;
  border: 1px solid rgba(221, 214, 254, 0.9);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 22px 48px rgba(62, 42, 92, 0.18);
  backdrop-filter: blur(18px);
  transform: translateX(-50%);
  animation: period-picker-in 150ms ease-out;
}

.period-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 13px;
}

.period-picker-header > span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.period-year-select {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.period-year-select select {
  width: 104px;
  height: 34px;
  padding: 0 29px 0 11px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  outline: 0;
  color: #241b35;
  font: inherit;
  font-size: 13px;
  font-weight: 900;
  background: #ffffff;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

.period-year-select select:focus-visible {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.period-year-select svg {
  position: absolute;
  right: 9px;
  width: 13px;
  height: 13px;
  color: #8b5cf6;
  pointer-events: none;
}

.period-month-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.period-month-grid button {
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  color: #475569;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  background: #f8fafc;
  cursor: pointer;
  transition: color 150ms ease, background-color 150ms ease, transform 150ms ease;
}

.period-month-grid button:hover {
  color: #7c3aed;
  background: #f3e8ff;
  transform: translateY(-1px);
}

.period-month-grid button.active {
  color: #ffffff;
  background: linear-gradient(135deg, #8b5cf6, #ec4899);
}

@keyframes period-picker-in {
  from {
    opacity: 0;
    transform: translate(-50%, -5px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
.schedule-today-button,
.schedule-filters button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  color: #5b4b7f;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease, transform 160ms ease;
}

.schedule-today-button:hover,
.schedule-filters button:hover {
  border-color: #c4b5fd;
  color: #7c3aed;
  background: #faf5ff;
  transform: translateY(-1px);
}

.schedule-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.schedule-filters button.active {
  border-color: transparent;
  color: #ffffff;
  background: linear-gradient(135deg, #8b5cf6, #ec4899);
  box-shadow: 0 8px 18px rgba(124, 58, 237, 0.2);
}

.calendar-drag-hint {
  flex: 1 0 100%;
  margin-left: auto;
  color: #8b7aa3;
  font-size: 10px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.schedule-main-panel {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
  min-height: 0;
}

.schedule-main-panel.panel-open {
  grid-template-columns: minmax(0, 1fr) 330px;
}

.schedule-calendar,
.schedule-side-panel {
  position: relative;
  min-height: 650px;
  overflow: hidden;
  border-radius: var(--schedule-card-radius);
}

.schedule-calendar::before,
.schedule-side-panel::before,
.schedule-modal::before {
  position: absolute;
  top: 0;
  left: 28px;
  z-index: 2;
  width: 74px;
  height: 4px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, #8b5cf6, #38bdf8);
  content: "";
}

.schedule-side-panel::before {
  background: linear-gradient(90deg, #ec4899, #fb7185);
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  margin: 14px 14px 0;
  padding-top: 5px;
  border: 1px solid rgba(221, 214, 254, 0.54);
  border-bottom: 0;
  border-radius: var(--schedule-inner-radius) var(--schedule-inner-radius) 0 0;
  background: rgba(248, 245, 255, 0.74);
}

.calendar-weekdays div {
  padding: 11px 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
}

.calendar-weekdays div:first-child {
  color: #e11d48;
}

.calendar-weekdays div:last-child {
  color: #7c3aed;
}

.calendar-grid {
  position: relative;
  display: flex;
  min-height: 574px;
  flex-direction: column;
  margin: 0 14px 14px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid rgba(221, 214, 254, 0.54);
  border-radius: 0 0 var(--schedule-inner-radius) var(--schedule-inner-radius);
  background: rgba(255, 255, 255, 0.58);
}

.calendar-grid.loading {
  pointer-events: none;
}

.calendar-week {
  position: relative;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  flex: 0 0 auto;
  min-width: 0;
}

.calendar-day {
  position: relative;
  min-width: 0;
  min-height: 100%;
  padding: 9px;
  border-right: 1px solid rgba(226, 232, 240, 0.72);
  border-bottom: 1px solid rgba(226, 232, 240, 0.72);
  background: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.calendar-day:nth-child(7n) {
  border-right: 0;
}

.calendar-week:nth-child(6) .calendar-day {
  border-bottom: 0;
}

.calendar-day:hover {
  background: rgba(250, 245, 255, 0.9);
}

.calendar-day.other-month {
  background: rgba(248, 250, 252, 0.64);
}

.calendar-day.today {
  background: rgba(243, 232, 255, 0.54);
}

.calendar-day.selected {
  position: relative;
  z-index: 1;
  background: linear-gradient(145deg, rgba(245, 243, 255, 0.96), rgba(253, 242, 248, 0.86));
  box-shadow: inset 0 0 0 2px rgba(124, 58, 237, 0.58);
}

.calendar-day.drag-target {
  position: relative;
  z-index: 3;
  background: #f3efff;
  box-shadow: inset 0 0 0 2px #8b5cf6;
}

.calendar-day.drag-target::after {
  position: absolute;
  inset: 5px;
  z-index: 4;
  border: 1px dashed #8b5cf6;
  border-radius: 10px;
  content: "";
  pointer-events: none;
}

.calendar-drop-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  padding: 5px 8px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 9px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
  background: #7c3aed;
  box-shadow: 0 7px 18px rgba(109, 40, 217, 0.28);
  pointer-events: none;
  transform: translate(-50%, -50%);
}

.calendar-day-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.calendar-day-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}

.day-add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  padding: 0;
  border: 1px solid rgba(196, 181, 253, 0.9);
  border-radius: 8px;
  color: #7c3aed;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 5px 12px rgba(124, 58, 237, 0.12);
  cursor: pointer;
  opacity: 0;
  transform: translateY(-3px) scale(0.9);
  transition: opacity 150ms ease, transform 150ms ease, color 150ms ease, background-color 150ms ease;
  pointer-events: none;
}

.day-add-button svg {
  width: 14px;
  height: 14px;
}

.calendar-day:hover .day-add-button,
.calendar-day:focus-within .day-add-button,
.day-add-button:focus-visible {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.day-add-button:hover {
  color: #ffffff;
  background: #7c3aed;
}

.day-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 999px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.other-month .day-number {
  color: #cbd5e1;
}

.today .day-number {
  color: #ffffff;
  background: linear-gradient(135deg, #7c3aed, #ec4899);
  box-shadow: 0 5px 12px rgba(124, 58, 237, 0.24);
}

.selected .day-number {
  color: #ffffff;
  background: #7c3aed;
}

.today-chip {
  flex-shrink: 0;
  padding: 3px 6px;
  border-radius: 999px;
  color: #e11d48;
  font-size: 9px;
  font-weight: 900;
  background: #fff1f2;
}

.calendar-week-events {
  position: absolute;
  top: 38px;
  right: 0;
  left: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-auto-rows: 28px;
  gap: 4px 0;
  pointer-events: none;
}

.calendar-event {
  position: relative;
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  border: 1px solid rgba(167, 243, 208, 0.74);
  border-left: 3px solid #10b981;
  border-radius: 9px;
  color: #065f46;
  font: inherit;
  text-align: left;
  background: linear-gradient(135deg, rgba(236, 253, 245, 0.96), rgba(240, 253, 250, 0.82));
  cursor: pointer;
  transition: transform 150ms ease, box-shadow 150ms ease;
}

.calendar-week-events .calendar-event {
  width: auto;
  height: 28px;
  margin: 0 7px;
  padding: 4px 7px;
  pointer-events: auto;
}

.calendar-event.multi-day {
  background: linear-gradient(90deg, rgba(209, 250, 229, 0.98), rgba(236, 253, 245, 0.9));
  box-shadow: inset 3px 0 #10b981;
}

.calendar-event.personal-event.multi-day {
  background: linear-gradient(90deg, rgba(237, 233, 254, 0.98), rgba(250, 245, 255, 0.9));
  box-shadow: inset 3px 0 #8b5cf6;
}

.calendar-event.draggable {
  cursor: grab;
}

.calendar-event.draggable:active {
  cursor: grabbing;
}

.calendar-event.dragging {
  opacity: 0.45;
}

.calendar-event.moving {
  cursor: wait;
  opacity: 0.65;
}

.event-memory-thumb {
  position: absolute;
  top: 5px;
  right: 5px;
  display: block;
  overflow: hidden;
  width: 22px;
  height: 22px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  background: #fff;
}

.event-memory-thumb img,
.side-event-memory-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.calendar-event:has(.event-memory-thumb) {
  padding-right: 35px;
}

.calendar-event:hover {
  box-shadow: 0 6px 14px rgba(16, 185, 129, 0.12);
  transform: translateY(-1px);
}

.calendar-event.personal-event {
  border-color: rgba(221, 214, 254, 0.84);
  border-left-color: #8b5cf6;
  color: #5b21b6;
  background: linear-gradient(135deg, rgba(245, 243, 255, 0.98), rgba(253, 242, 248, 0.86));
}

.calendar-event.personal-event:hover {
  box-shadow: 0 6px 14px rgba(124, 58, 237, 0.13);
}

.event-category,
.event-title,
.side-event-title,
.side-event-category {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-category {
  flex: 0 1 auto;
  max-width: 36%;
  color: #047857;
  font-size: 9px;
  font-weight: 800;
}

.event-title {
  flex: 1 1 auto;
  min-width: 0;
  color: #064e3b;
  font-size: 11px;
  font-weight: 800;
}

.event-time {
  flex: 0 0 auto;
  color: #047857;
  font-size: 9px;
  white-space: nowrap;
}

.calendar-event.personal-event .event-category,
.calendar-event.personal-event .event-time {
  color: #7c3aed;
}

.calendar-event.personal-event .event-title {
  color: #4c1d95;
}

.calendar-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-width: 0;
  min-height: 20px;
  padding: 0 7px;
  border: 0;
  border-radius: 6px;
  color: #7c3aed;
  font: inherit;
  font-size: 10px;
  font-weight: 800;
  text-align: left;
  background: rgba(237, 233, 254, 0.72);
  cursor: pointer;
  transition: color 150ms ease, background-color 150ms ease;
}

.calendar-more:hover,
.calendar-more:focus-visible {
  color: #5b21b6;
  background: #ddd6fe;
}

.calendar-loading {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.76);
  backdrop-filter: blur(5px);
}

.loading-dot {
  width: 16px;
  height: 16px;
  border: 2px solid #ddd6fe;
  border-top-color: #7c3aed;
  border-radius: 999px;
  animation: schedule-spin 0.7s linear infinite;
}

@keyframes schedule-spin {
  to {
    transform: rotate(360deg);
  }
}
.schedule-side-panel {
  display: flex;
  flex-direction: column;
  animation: schedule-side-panel-in 180ms ease-out;
}

.side-panel-header {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 24px 22px 18px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.72);
}

.side-panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.side-panel-heading > span {
  width: max-content;
  padding: 4px 8px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  background: #f3e8ff;
}

.side-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 10px;
  color: #64748b;
  background: rgba(255, 255, 255, 0.82);
  cursor: pointer;
  transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease, transform 160ms ease;
}

.side-panel-close:hover {
  border-color: #c4b5fd;
  color: #7c3aed;
  background: #f5f3ff;
  transform: translateY(-1px);
}

.side-panel-close svg {
  width: 16px;
  height: 16px;
}

.side-panel-header strong {
  color: #0f172a;
  font-size: 17px;
  line-height: 1.3;
}

.side-list {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding: 16px;
}

.side-empty {
  display: flex;
  align-items: center;
  flex: 1;
  min-height: 112px;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 18px;
  border: 1px dashed #ddd6fe;
  border-radius: var(--schedule-inner-radius);
  color: #64748b;
  text-align: center;
  background: rgba(250, 248, 255, 0.7);
}

.side-empty strong {
  color: #334155;
  font-size: 13px;
}

.side-empty span {
  font-size: 11px;
}

.side-add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid #c4b5fd;
  border-radius: 12px;
  color: #6d28d9;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  background: #f8f5ff;
  cursor: pointer;
  transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease;
}

.side-add-button:hover {
  border-color: #8b5cf6;
  color: #ffffff;
  background: #8b5cf6;
}

.side-add-button svg {
  width: 16px;
  height: 16px;
}

.side-event {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 5px 11px;
  width: 100%;
  padding: 13px;
  border: 1px solid rgba(226, 232, 240, 0.84);
  border-radius: var(--schedule-inner-radius);
  color: #0f172a;
  font: inherit;
  text-align: left;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 8px 20px rgba(91, 70, 124, 0.05);
  cursor: pointer;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.side-event:hover {
  border-color: rgba(124, 58, 237, 0.25);
  box-shadow: 0 12px 24px rgba(91, 70, 124, 0.1);
  transform: translateY(-2px);
}

.side-event.draggable {
  cursor: grab;
}

.side-event.draggable:active {
  cursor: grabbing;
}

.side-event.dragging {
  opacity: 0.45;
}

.side-event.moving {
  cursor: wait;
  opacity: 0.65;
}

.side-event.personal-event {
  border-color: rgba(221, 214, 254, 0.92);
  background: linear-gradient(145deg, rgba(250, 248, 255, 0.98), rgba(253, 242, 248, 0.76));
}

.side-event-time {
  grid-column: 1;
  align-self: start;
  min-width: 0;
  color: #7c3aed;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.25;
  overflow-wrap: anywhere;
  white-space: normal;
}

.side-event-copy {
  display: grid;
  grid-column: 1;
  min-width: 0;
  gap: 5px;
}

.side-event-title {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.side-event-category {
  color: #64748b;
  font-size: 11px;
}

.side-event-memo {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 6px;
  color: #475569;
  font-size: 11px;
  line-height: 1.45;
}

.side-event-memo em {
  flex-shrink: 0;
  padding: 1px 5px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #f3e8ff;
}

.side-event-memo span {
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.side-event-memory-thumb {
  display: block;
  overflow: hidden;
  width: 38px;
  height: 38px;
  align-self: center;
  grid-column: 2;
  grid-row: 1/span 2;
  border: 1px solid #e4dcf3;
  border-radius: 9px;
  background: #faf8ff;
}

.side-event.personal-event .side-event-time,
.side-event.personal-event .side-event-category {
  color: #7c3aed;
}

@keyframes schedule-side-panel-in {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.schedule-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(30, 20, 48, 0.46);
  backdrop-filter: blur(8px);
}

.schedule-modal {
  position: relative;
  display: flex;
  width: min(560px, 100%);
  max-height: min(720px, 100vh - 48px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 22px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.99), rgba(251, 248, 255, 0.96));
  box-shadow: 0 30px 90px rgba(36, 22, 58, 0.32);
}

.schedule-modal::before {
  background: linear-gradient(90deg, #8b5cf6, #ec4899);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 18px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.72);
}

.modal-title {
  min-width: 0;
}

.modal-category {
  display: inline-flex;
  margin-bottom: 9px;
  padding: 4px 9px;
  border-radius: 999px;
  color: #047857;
  font-size: 10px;
  font-weight: 900;
  background: #dcfce7;
}

.modal-category.personal {
  color: #7c3aed;
  background: #f3e8ff;
}

.modal-title h2 {
  margin: 0;
  color: #0f172a;
  font-size: 21px;
  font-weight: 900;
  line-height: 1.25;
}

.modal-title p {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  color: #475569;
  background: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  transition: border-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.modal-close:hover {
  border-color: #c4b5fd;
  color: #7c3aed;
  transform: translateY(-1px);
}

.modal-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 24px;
}

.modal-meta div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
  padding: 12px;
  border: 1px solid rgba(226, 232, 240, 0.76);
  border-radius: 13px;
  background: rgba(248, 250, 252, 0.7);
}

.modal-meta span {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 800;
}

.modal-meta strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-content {
  margin: 0 24px 18px;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid rgba(221, 214, 254, 0.62);
  border-radius: 13px;
  background: rgba(250, 248, 255, 0.72);
}

.modal-content-label {
  display: block;
  margin-bottom: 7px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
}

.modal-content p {
  margin: 0;
  color: #334155;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 15px 24px 20px;
  border-top: 1px solid rgba(226, 232, 240, 0.72);
  background: rgba(248, 245, 255, 0.58);
}

.modal-footer button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 15px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  color: #475569;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  background: #ffffff;
  cursor: pointer;
}

.modal-footer button.primary {
  border-color: transparent;
  color: #ffffff;
  background: linear-gradient(135deg, #7c3aed, #e11d48);
  box-shadow: 0 10px 22px rgba(124, 58, 237, 0.22);
}

.modal-footer button.danger {
  margin-right: auto;
  border-color: #fecdd3;
  color: #be123c;
  background: #fff1f2;
}

.modal-footer button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.personal-schedule-modal {
  width: min(620px, 100%);
}

.personal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  padding: 22px 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.form-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.form-field > span {
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.form-field input,
.form-field textarea,
.form-field select,
.schedule-form-section select,
.schedule-form-section input[type=number],
.schedule-form-section input[type=date] {
  width: 100%;
  min-width: 0;
  border: 1px solid #ddd6e7;
  border-radius: 12px;
  outline: 0;
  color: #1e293b;
  font: inherit;
  font-size: 13px;
  background: rgba(255, 255, 255, 0.9);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-field input {
  height: 44px;
  padding: 0 13px;
}

.form-field textarea {
  min-height: 104px;
  padding: 12px 13px;
  line-height: 1.55;
  resize: vertical;
}

.form-field input:focus,
.form-field textarea:focus,
.form-field select:focus,
.schedule-form-section select:focus,
.schedule-form-section input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.form-field select,
.schedule-form-section select {
  height: 44px;
  padding: 0 36px 0 13px;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

.form-select-shell {
  position: relative;
  width: 100%;
  min-width: 0;
}

.form-select-shell > svg {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 16px;
  height: 16px;
  color: #7c3aed;
  pointer-events: none;
  transform: translateY(-50%);
  transition: color 160ms ease, transform 160ms ease;
}

.form-select-shell:focus-within > svg {
  color: #5b21b6;
  transform: translateY(-50%) scale(1.08);
}

.schedule-form-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  border: 1px solid rgba(221, 214, 254, 0.76);
  border-radius: 16px;
  background: rgba(250, 248, 255, 0.72);
}

.schedule-form-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.schedule-form-section-heading > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.section-collapse-button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  color: #6d28d9;
  font: inherit;
  font-size: 11px;
  font-weight: 900;
  background: transparent;
  cursor: pointer;
}

.section-collapse-button:hover,
.section-collapse-button:focus-visible {
  outline: 0;
  background: #f0eafe;
}

.section-collapse-button svg {
  width: 15px;
  height: 15px;
  transition: transform 160ms ease;
}

.section-collapse-button svg.open {
  transform: rotate(180deg);
}

.schedule-form-section-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.option-button-group {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.option-button-group button {
  min-height: 36px;
  min-width: 0;
  padding: 6px 5px;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  color: #64748b;
  font: inherit;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  background: #fff;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.option-button-group button:hover:not(:disabled),
.option-button-group button:focus-visible {
  border-color: #a78bfa;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.option-button-group button.active {
  border-color: #8b5cf6;
  color: #fff;
  background: #8b5cf6;
}

.option-button-group button:disabled {
  border-color: #e2e8f0;
  color: #94a3b8;
  background: #f8fafc;
  cursor: not-allowed;
  opacity: 0.72;
}

.schedule-form-section-heading strong,
.recurrence-end > span,
.weekday-field > span,
.edit-scope-field > span {
  color: #312e81;
  font-size: 13px;
  font-weight: 900;
}

.schedule-form-section-heading small,
.compact-field small {
  color: #7c8497;
  font-size: 11px;
  font-style: normal;
}

.recurrence-custom,
.recurrence-end,
.edit-scope-field,
.reminder-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.inline-number-field,
.compact-field,
.reminder-row,
.reminder-custom {
  display: flex;
  align-items: center;
  gap: 8px;
}

.inline-number-field,
.compact-field {
  width: max-content;
  max-width: 100%;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: nowrap;
}

.recurrence-interval,
.recurrence-interval .inline-number-field {
  width: 100%;
}

.recurrence-interval .inline-number-field {
  max-width: none;
  flex: 1 1 auto;
}

.reminder-row {
  width: 100%;
  flex-direction: column;
  align-items: stretch;
}

.reminder-option-buttons {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.reminder-option-buttons.with-none {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.reminder-row-heading {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.reminder-row-heading button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  color: #be123c;
  font: inherit;
  font-size: 10px;
  font-weight: 900;
  background: #fff;
  cursor: pointer;
}

.reminder-custom {
  flex: 1 1 100%;
}

.inline-number-field input,
.compact-field input,
.reminder-custom input {
  width: 110px;
  height: 40px;
  padding: 0 11px;
}

.recurrence-interval .inline-number-field input {
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
}

.inline-number-field em,
.compact-field small,
.reminder-custom span {
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.weekday-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.weekday-options {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 6px;
}

.weekday-options button {
  height: 34px;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  color: #64748b;
  font: inherit;
  font-size: 11px;
  font-weight: 800;
  background: #fff;
  cursor: pointer;
}

.weekday-options button.active {
  border-color: #8b5cf6;
  color: #fff;
  background: #8b5cf6;
}

.recurrence-end-options,
.edit-scope-field label {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.recurrence-end-choice > label:first-child,
.edit-scope-field label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.recurrence-end-options {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px 24px;
}

.recurrence-end-choice {
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 8px;
}

.count-choice {
  align-items: center;
  flex-wrap: nowrap;
}

.count-choice .recurrence-count-field {
  width: auto;
  max-width: none;
  min-width: 0;
  flex: 1 1 auto;
}

.count-choice .recurrence-count-field input {
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
}

.date-choice {
  align-items: flex-start;
  flex-direction: column;
  gap: 6px;
}

.recurrence-date-field {
  position: relative;
  width: calc(100% - 23px);
  max-width: none;
  margin-left: 23px;
}

.recurrence-date-field input {
  width: 100%;
  min-width: 0;
}

.reminder-add {
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  color: #6d28d9;
  font: inherit;
  font-size: 12px;
  font-weight: 800;
  background: #fff;
  cursor: pointer;
}

.reminder-add {
  align-self: stretch;
  width: 100%;
  min-height: 36px;
  padding: 0 12px;
}

.reminder-add:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@media (min-width: 901px) {
  .schedule-page {
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }
  .schedule-topbar {
    flex: 0 0 auto;
  }
  .schedule-content,
  .schedule-main-panel {
    flex: 1 1 auto;
    min-height: 0;
  }
  .schedule-calendar {
    display: flex;
    min-height: 0;
    flex-direction: column;
  }
  .schedule-side-panel {
    min-height: 0;
  }
  .calendar-toolbar,
  .calendar-weekdays {
    flex: 0 0 auto;
  }
  .calendar-grid {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }
  .calendar-day {
    display: flex;
    min-height: 0;
    flex-direction: column;
    padding: 6px 7px;
    overflow: hidden;
  }
  .calendar-day-head {
    flex: 0 0 auto;
  }
  .calendar-event {
    display: flex;
    min-height: 28px;
    padding: 5px 7px;
    border-radius: 7px;
  }
  .calendar-event .event-category,
  .calendar-event .event-time {
    display: block;
  }
  .calendar-event .event-title {
    display: block;
    padding-right: 0;
    font-size: 10px;
    line-height: 16px;
  }
  .event-memory-thumb {
    top: 4px;
    right: 4px;
    width: 18px;
    height: 18px;
  }
  .calendar-event:has(.event-memory-thumb) .event-title,
  .calendar-event:has(.event-memory-thumb) .event-time {
    padding-right: 0;
  }
  .calendar-more {
    min-height: 18px;
    line-height: 18px;
  }
}
@media (max-width: 1180px) {
  .schedule-main-panel.panel-open {
    grid-template-columns: minmax(0, 1fr) 300px;
  }
}
@media (max-width: 900px) {
  .schedule-page {
    padding: 24px 28px;
  }
  .calendar-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .schedule-filters {
    justify-content: flex-start;
  }
  .calendar-drag-hint {
    display: none;
  }
  .schedule-main-panel,
  .schedule-main-panel.panel-open {
    grid-template-columns: minmax(0, 1fr);
  }
  .schedule-side-panel {
    min-height: 280px;
  }
  .calendar-grid {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .calendar-weekdays {
    grid-template-columns: repeat(7, minmax(0, 1fr));
    overflow: hidden;
  }
}
@media (max-width: 640px) {
  .schedule-page {
    padding: 20px max(18px, env(safe-area-inset-right)) max(28px, env(safe-area-inset-bottom)) max(18px, env(safe-area-inset-left));
  }
  .schedule-title h1 {
    font-size: 25px;
  }
  .schedule-month-control {
    flex-wrap: wrap;
    width: 100%;
  }
  .month-navigation {
    flex: 1;
    width: auto;
    min-width: 260px;
  }
  .month-picker {
    min-width: 0;
  }
  .month-picker-wrap {
    flex: 1;
  }
  .month-picker {
    width: 100%;
  }
  .period-picker-dropdown {
    left: 0;
    width: min(276px, 100vw - 54px);
    animation: none;
    transform: none;
  }
  .schedule-calendar {
    min-height: 680px;
  }
  .calendar-weekdays {
    margin-right: 8px;
    margin-left: 8px;
  }
  .calendar-weekdays div {
    padding: 9px 1px;
    font-size: 10px;
  }
  .calendar-grid {
    min-height: 552px;
    margin-right: 8px;
    margin-left: 8px;
  }
  .calendar-day {
    min-height: 92px;
    padding: 5px 3px;
  }
  .calendar-day-head {
    gap: 2px;
  }
  .day-number {
    width: 21px;
    height: 21px;
    font-size: 10px;
  }
  .today-chip,
  .day-add-button {
    display: none;
  }
  .calendar-event {
    gap: 0;
    min-height: 18px;
    padding: 3px 2px;
    border-width: 0 0 0 2px;
    border-radius: 4px;
  }
  .event-category,
  .event-time {
    display: none;
  }
  .event-title {
    font-size: 8px;
    line-height: 1.4;
  }
  .calendar-more {
    min-height: 18px;
    padding: 0 5px;
    font-size: 8px;
  }
  .schedule-modal-backdrop {
    padding: 12px;
  }
  .modal-meta,
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .modal-header,
  .personal-form,
  .modal-meta,
  .modal-footer {
    padding-right: 18px;
    padding-left: 18px;
  }
}
@media (max-width: 560px) {
  .schedule-page {
    padding-right: max(14px, env(safe-area-inset-right));
    padding-left: max(14px, env(safe-area-inset-left));
  }
}
@media (max-width: 360px) {
  .schedule-title h1 {
    font-size: 24px;
  }
  .calendar-toolbar {
    padding-right: 10px;
    padding-left: 10px;
  }
  .schedule-month-control {
    gap: 5px;
  }
  .month-navigation {
    min-width: 0;
  }
  .month-arrow {
    width: 32px;
    flex-basis: 32px;
  }
  .month-picker {
    min-width: 0;
    padding-right: 6px;
    padding-left: 6px;
  }
  .schedule-today-button {
    padding-right: 9px;
    padding-left: 9px;
  }
  .schedule-modal-backdrop {
    padding: 8px;
  }
  .modal-footer {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .modal-footer button {
    width: 100%;
  }
}
@media (hover: none) {
  .day-add-button {
    opacity: 1;
    transform: none;
    pointer-events: auto;
  }
}
.schedule-modal:has(.event-detail-tabs) {
  width: min(760px, 100%);
  max-height: min(860px, 100dvh - 48px);
}

.event-detail-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin: 15px 24px 0;
  padding: 5px;
  border: 1px solid #e7e0f4;
  border-radius: 13px;
  background: #f8f6fc;
}

.event-detail-tabs.personal {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.event-detail-tabs button {
  min-height: 38px;
  border: 0;
  border-radius: 9px;
  color: #64748b;
  font: inherit;
  font-size: 11px;
  font-weight: 900;
  background: transparent;
}

.event-detail-tabs button.active {
  color: #6d28d9;
  background: #fff;
  box-shadow: 0 5px 14px rgba(91, 33, 182, 0.11);
}

.event-detail-tabs em {
  display: inline-grid;
  min-width: 18px;
  height: 18px;
  margin-left: 4px;
  padding: 0 4px;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 8px;
  font-style: normal;
  background: #8b5cf6;
}

.event-tab-panel {
  min-height: 0;
  overflow-y: auto;
}

.event-panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.event-panel-heading > div > span {
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.event-panel-heading h3 {
  margin: 4px 0 0;
  color: #1e293b;
  font-size: 16px;
}

.event-panel-heading p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 10px;
}

.event-panel-heading a,
.event-panel-heading > em {
  color: #6d28d9;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  text-decoration: none;
}

.itinerary-panel,
.expense-panel {
  display: grid;
  gap: 15px;
  margin: 16px 24px 18px;
  padding: 18px;
  border: 1px solid #e4dcfb;
  border-radius: 15px;
  background: linear-gradient(145deg, #fbf9ff, #fff);
}

.event-panel-empty {
  display: grid;
  min-height: 92px;
  padding: 16px;
  border: 1px dashed #ddd5ee;
  border-radius: 12px;
  place-items: center;
  color: #94a3b8;
  font-size: 11px;
  text-align: center;
  background: rgba(255, 255, 255, 0.72);
}

.event-itinerary-list {
  display: grid;
  gap: 8px;
}

.event-itinerary-list article {
  display: grid;
  grid-template-columns: 28px 72px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #ebe7f2;
  border-radius: 11px;
  background: #fff;
}

.event-itinerary-list article > em {
  display: grid;
  width: 25px;
  height: 25px;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #8b5cf6;
}

.event-itinerary-list time,
.event-itinerary-list small {
  color: #7c3aed;
  font-size: 10px;
  font-weight: 800;
}

.event-itinerary-list strong {
  color: #1e293b;
  font-size: 12px;
}

.event-itinerary-list p {
  margin: 4px 0;
  color: #64748b;
  font-size: 10px;
}

.personal-memory-section {
  display: grid;
  gap: 14px;
  margin: 16px 24px 18px;
  overflow-y: auto;
  padding: 17px;
  border: 1px solid #e4dcfb;
  border-radius: 15px;
  background: linear-gradient(145deg, #fbf9ff, #fffafd);
}

.personal-memory-heading,
.personal-memory-actions {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.personal-memory-heading span {
  display: block;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.personal-memory-heading h3 {
  margin: 4px 0 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 900;
}

.personal-memory-heading p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 10px;
}

.personal-memory-heading em {
  padding: 6px 9px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #ede9fe;
  white-space: nowrap;
}

.personal-memory-loading {
  display: grid;
  min-height: 100px;
  place-items: center;
  color: #94a3b8;
  font-size: 11px;
}

.personal-memory-editor {
  display: grid;
  gap: 12px;
}

.personal-memory-photos {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 7px;
  border: 1px dashed transparent;
  border-radius: 12px;
  transition: border-color 160ms ease, background-color 160ms ease;
}

.personal-memory-photos.drag-active {
  border-color: #8b5cf6;
  background: #f5f1ff;
}

.memory-file-input {
  display: none;
}

.memory-drop-hint {
  grid-column: 1/-1;
  color: #94a3b8;
  font-size: 9px;
  text-align: center;
}

.personal-memory-photo,
.personal-memory-photo-add {
  position: relative;
  overflow: hidden;
  aspect-ratio: 4/3;
  border-radius: 10px;
}

.personal-memory-photo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f3f8;
}

.personal-memory-photo button {
  position: absolute;
  top: 5px;
  right: 5px;
  display: grid;
  width: 23px;
  height: 23px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 15px;
  background: rgba(15, 23, 42, 0.72);
}

.personal-memory-photo-add {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 5px;
  border: 1px dashed #c4b5fd;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.7);
}

.personal-memory-photo-add svg {
  width: 21px;
  height: 21px;
}

.personal-memory-review {
  position: relative;
}

.personal-memory-review textarea {
  width: 100%;
  min-height: 92px;
  padding: 11px 12px 25px;
  border: 1px solid #ddd6ee;
  border-radius: 10px;
  outline: none;
  color: #334155;
  font: inherit;
  font-size: 11px;
  line-height: 1.6;
  background: #fff;
  resize: vertical;
}

.personal-memory-review textarea:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
}

.personal-memory-review small {
  position: absolute;
  right: 10px;
  bottom: 8px;
  color: #94a3b8;
  font-size: 8px;
}

.personal-memory-actions {
  align-items: center;
  justify-content: flex-end;
}

.personal-memory-actions button {
  min-height: 36px;
  padding: 0 13px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 900;
}

.personal-memory-delete {
  margin-right: auto;
  border: 1px solid #fecdd3;
  color: #be123c;
  background: #fff;
}

.personal-memory-save {
  display: inline-flex;
  min-width: 112px;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  font: inherit;
  font-size: 12px;
  font-weight: 900;
  background: linear-gradient(135deg, #7c3aed, #db2777);
  box-shadow: 0 10px 22px rgba(124, 58, 237, 0.2);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.personal-memory-save:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 13px 26px rgba(124, 58, 237, 0.26);
}

.personal-memory-actions button:disabled,
.personal-memory-photo-add:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.memory-gallery {
  display: grid;
  gap: 10px;
  margin-top: 2px;
}

.event-memory-card {
  padding: 13px;
  border: 1px solid #e7e1f1;
  border-radius: 12px;
  background: #fff;
}

.event-memory-card header,
.event-memory-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.event-memory-card header > div {
  display: grid;
  gap: 2px;
}

.event-memory-card header strong {
  color: #334155;
  font-size: 11px;
}

.event-memory-card header small {
  color: #94a3b8;
  font-size: 9px;
}

.event-memory-card header button {
  padding: 5px 8px;
  border: 1px solid #fecdd3;
  border-radius: 7px;
  color: #be123c;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.event-memory-card > p {
  margin: 10px 0 0;
  color: #475569;
  font-size: 11px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.event-memory-photos {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 10px;
}

.event-memory-photos.single {
  grid-template-columns: minmax(0, 1fr);
}

.event-memory-photos button {
  overflow: hidden;
  padding: 0;
  border: 1px solid #ebe7f1;
  border-radius: 9px;
  background: #f6f4f8;
  cursor: zoom-in;
}

.event-memory-photos img {
  width: 100%;
  max-height: 280px;
  aspect-ratio: 4/3;
  object-fit: contain;
}

.event-memory-controls {
  justify-content: flex-start;
}

.event-memory-controls label {
  cursor: pointer;
}

.event-memory-controls input {
  position: absolute;
  opacity: 0;
}

.event-memory-controls label span {
  display: block;
  padding: 7px 9px;
  border: 1px solid #ddd6ee;
  border-radius: 8px;
  color: #64748b;
  font-size: 9px;
  font-weight: 800;
}

.event-memory-controls input:checked + span {
  border-color: #a78bfa;
  color: #6d28d9;
  background: #f5f3ff;
}

.event-memory-controls > button {
  margin-left: auto;
}

.event-expense-entry {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(90px, 0.7fr) minmax(110px, 0.8fr) auto;
  gap: 7px;
}

.event-expense-entry > button {
  grid-column: 4;
  grid-row: 1;
}

.event-expense-participants {
  display: grid;
  grid-column: 1/-1;
  gap: 7px;
}

.event-expense-participants > span {
  color: #475569;
  font-size: 9px;
  font-weight: 800;
}

.event-expense-participants > span em {
  margin-left: 5px;
  color: #7c3aed;
  font-style: normal;
}

.event-expense-participants > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.event-expense-participants button {
  display: inline-flex;
  min-height: 31px;
  height: 31px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #ddd6e8;
  border-radius: 999px;
  color: #64748b;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.event-expense-participants button.selected {
  border-color: #7c3aed;
  color: #5b21b6;
  background: #ede9fe;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.12);
}

.event-expense-check {
  display: grid;
  width: 17px;
  height: 17px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  place-items: center;
  color: transparent;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.event-expense-participants button.selected .event-expense-check {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.event-expense-participants button strong {
  font-size: 9px;
  font-weight: 900;
}

.event-expense-entry input,
.event-expense-entry select,
.event-expense-entry > button {
  min-width: 0;
  height: 36px;
  padding: 0 9px;
  border: 1px solid #ddd6e8;
  border-radius: 8px;
  color: #334155;
  font: inherit;
  font-size: 10px;
  background: #fff;
}

.event-expense-entry > button {
  border-color: #7c3aed;
  color: #fff;
  font-weight: 900;
  background: #7c3aed;
}

.event-expense-list {
  overflow: hidden;
  border: 1px solid #e7e2ef;
  border-radius: 11px;
}

.event-expense-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border-bottom: 1px solid #eeeaf4;
}

.event-expense-list article:last-child {
  border-bottom: 0;
}

.event-expense-list strong,
.event-expense-list small {
  display: block;
}

.event-expense-list strong {
  color: #334155;
  font-size: 13px;
}

.event-expense-list small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.45;
}

.event-expense-list em {
  color: #1e293b;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.event-expense-list button {
  width: 25px;
  height: 25px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  color: #be123c;
  background: #fff1f2;
}

.event-payment-panel {
  display: grid;
  gap: 10px;
  padding: 13px;
  border: 1px solid #ded6f1;
  border-radius: 11px;
  background: #fbfaff;
}

.event-payment-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.event-payment-panel > header strong,
.event-payment-panel > header span {
  display: block;
}

.event-payment-panel > header strong {
  color: #4c1d95;
  font-size: 13px;
}

.event-payment-panel > header span {
  margin-top: 3px;
  color: #7c7193;
  font-size: 10px;
}

.event-payment-panel > header em {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #ede9fe;
}

.event-payment-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.event-payment-list article {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 9px;
  border: 1px solid #ebe7f3;
  border-radius: 8px;
  background: #fff;
}

.event-payment-list article > div {
  min-width: 0;
}

.event-payment-list strong {
  color: #334155;
  font-size: 11px;
}

.event-payment-list p {
  margin: 4px 0 0;
  color: #6d28d9;
  font-size: 10px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.event-payment-list button {
  flex: 0 0 auto;
  padding: 4px 7px;
  border: 1px solid #fecdd3;
  border-radius: 6px;
  color: #be123c;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.event-payment-empty {
  margin: 0;
  padding: 9px;
  border-radius: 8px;
  color: #94a3b8;
  font-size: 10px;
  text-align: center;
  background: #fff;
}

.event-payment-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 8px;
}

.event-payment-editor label {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.event-payment-editor label > span {
  color: #475569;
  font-size: 9px;
  font-weight: 800;
}

.event-payment-editor textarea {
  width: 100%;
  min-height: 76px;
  padding: 9px 10px;
  border: 1px solid #d8d1e9;
  border-radius: 8px;
  outline: none;
  color: #334155;
  font: inherit;
  font-size: 10px;
  line-height: 1.5;
  background: #fff;
  resize: vertical;
}

.event-payment-editor textarea:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.event-payment-editor label > small {
  justify-self: end;
  color: #94a3b8;
  font-size: 8px;
}

.event-payment-editor > button {
  min-width: 74px;
  min-height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  font: inherit;
  font-size: 10px;
  font-weight: 900;
  background: #7c3aed;
}

.event-payment-editor > button:disabled,
.event-payment-list button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.event-settlement {
  padding: 14px;
  border-radius: 11px;
  background: #f3efff;
}

.event-settlement strong {
  color: #5b21b6;
  font-size: 15px;
}

.event-settlement p {
  margin: 7px 0 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.event-transfer-row {
  display: grid;
  gap: 2px;
  margin-top: 9px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fff;
}

.event-transfer-row p {
  margin: 0;
}

.event-transfer-row small {
  color: #6d28d9;
  font-size: 11px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.schedule-image-lightbox {
  position: fixed;
  inset: 0;
  z-index: 180;
  display: grid;
  padding: 56px;
  place-items: center;
  background: rgba(10, 12, 20, 0.88);
  backdrop-filter: blur(8px);
}

.schedule-image-lightbox > img {
  max-width: min(1180px, 100%);
  max-height: calc(100dvh - 112px);
  object-fit: contain;
  border-radius: 12px;
}

.schedule-image-lightbox > button {
  position: absolute;
  top: 20px;
  right: 24px;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  color: #fff;
  font-size: 24px;
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 560px) {
  .event-detail-tabs {
    display: flex;
    overflow-x: auto;
    margin-right: 18px;
    margin-left: 18px;
  }
  .event-detail-tabs button {
    min-width: 82px;
    flex: 1 0 auto;
  }
  .personal-memory-section {
    margin-right: 18px;
    margin-left: 18px;
    padding: 14px;
  }
  .personal-memory-photos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .itinerary-panel,
  .expense-panel {
    margin-right: 18px;
    margin-left: 18px;
    padding: 14px;
  }
  .event-itinerary-list article {
    grid-template-columns: 28px minmax(0, 1fr);
  }
  .event-itinerary-list time {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
  }
  .event-itinerary-list article > div {
    grid-column: 2;
  }
  .event-expense-entry {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .event-expense-entry > button {
    grid-column: 1/-1;
    grid-row: auto;
  }
  .event-payment-list,
  .event-payment-editor {
    grid-template-columns: minmax(0, 1fr);
  }
  .event-payment-editor > button {
    width: 100%;
  }
  .personal-memory-save {
    width: 100%;
  }
  .schedule-image-lightbox {
    padding: 48px 14px 22px;
  }
}
.event-payment-list .payment-info-card {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  min-width: 0;
  gap: 11px;
  padding: 13px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.event-payment-list .payment-info-card.mine {
  border-color: #cfc1fa;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.055);
}

.payment-info-actions {
  position: static;
  display: flex;
  grid-column: 2;
  grid-row: 1;
  align-items: center;
  align-self: start;
  justify-self: end;
  gap: 3px;
}

.payment-info-actions button {
  position: static;
  display: inline-flex;
  width: 27px;
  height: 27px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  background: transparent;
}

.payment-info-actions .payment-info-edit {
  width: auto;
  gap: 3px;
  padding: 0 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
}

.event-payment-list .payment-info-edit:hover:not(:disabled) {
  background: #f4f0ff;
}

.event-payment-list .payment-info-delete:hover:not(:disabled) {
  color: #be123c;
  background: #fff1f3;
}

.payment-info-actions svg {
  width: 14px;
  height: 14px;
}

.payment-info-card-heading {
  display: flex;
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  align-items: center;
  gap: 8px;
  padding-right: 0;
}

.payment-info-avatar {
  display: grid;
  overflow: hidden;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  border-radius: 999px;
  place-items: center;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #eee9ff;
}

.payment-info-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.payment-info-card-heading strong,
.payment-info-card-heading > div > span {
  display: block;
}

.payment-info-card-heading > div > span {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 8px;
}

.payment-account-summary {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  grid-column: 1/-1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 11px;
  margin: 0;
  padding-top: 10px;
  border-top: 1px solid #ece8f4;
}

.payment-account-primary {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.payment-bank-chip {
  display: inline-flex;
  min-height: 26px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f0ebff;
}

.payment-account-number {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.payment-account-number small {
  color: #94a3b8;
  font-size: 8px;
  font-weight: 800;
}

.payment-account-number strong {
  min-width: 0;
  color: #334155;
  font-size: 10px;
  font-variant-numeric: tabular-nums;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.event-payment-list .payment-account-copy {
  display: inline-flex;
  min-height: 27px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding: 0 7px;
  border: 1px solid #ddd6fe;
  border-radius: 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.event-payment-list .payment-account-copy:hover:not(:disabled) {
  background: #f7f3ff;
}

.payment-account-copy svg {
  width: 11px;
  height: 11px;
}

.event-payment-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 13px;
  margin-top: 3px;
  padding: 14px;
  border: 1px solid #ded6fb;
  border-radius: 10px;
  background: linear-gradient(145deg, #faf8ff, #fdfcff);
}

.event-payment-editor > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.event-payment-editor > header strong,
.event-payment-editor > header div > span {
  display: block;
}

.event-payment-editor > header strong {
  color: #3b2a68;
  font-size: 11px;
}

.event-payment-editor > header div > span {
  margin-top: 3px;
  color: #7c7193;
  font-size: 8px;
  line-height: 1.5;
}

.payment-editor-status {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #eee9ff;
}

.payment-editor-fields {
  display: grid;
  grid-template-columns: minmax(150px, 0.42fr) minmax(220px, 1fr);
  align-items: start;
  gap: 9px;
}

.event-payment-editor .payment-editor-fields > label {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.event-payment-editor .payment-editor-fields > label > span {
  color: #475569;
  font-size: 9px;
  font-weight: 900;
}

.payment-bank-control {
  position: relative;
  min-width: 0;
}

.payment-bank-control input,
.event-payment-editor .payment-editor-fields > label > input {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #d8dce5;
  border-radius: 8px;
  outline: none;
  color: #334155;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  background: #fff;
}

.payment-bank-control input {
  padding-right: 31px;
}

.payment-bank-control input:focus,
.event-payment-editor .payment-editor-fields > label > input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.payment-bank-toggle {
  position: absolute;
  top: 50%;
  right: 4px;
  display: grid;
  width: 29px;
  height: 29px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #94a3b8;
  background: transparent;
  transform: translateY(-50%);
}

.payment-bank-toggle:hover:not(:disabled) {
  color: #6d28d9;
  background: #f4f0ff;
}

.payment-bank-toggle svg {
  width: 13px;
  height: 13px;
  transition: transform 150ms ease;
}

.payment-bank-combobox.open .payment-bank-toggle svg {
  transform: rotate(180deg);
}

.payment-bank-control input:disabled,
.event-payment-editor .payment-editor-fields > label > input:disabled {
  cursor: not-allowed;
  color: #94a3b8;
  background: #f2f3f6;
}

.payment-bank-options {
  display: grid;
  overflow-y: auto;
  max-height: 166px;
  margin-top: 5px;
  padding: 5px;
  border: 1px solid #ddd6ee;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 11px 24px rgba(31, 24, 52, 0.1);
}

.payment-bank-options button {
  display: flex;
  min-height: 32px;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  color: #475569;
  font-size: 9px;
  font-weight: 800;
  text-align: left;
  background: transparent;
}

.payment-bank-options button:hover,
.payment-bank-options button.selected {
  color: #6d28d9;
  background: #f4f0ff;
}

.payment-bank-options button svg {
  width: 12px;
  height: 12px;
}

.payment-bank-options p {
  margin: 0;
  padding: 12px 7px;
  color: #94a3b8;
  font-size: 9px;
  text-align: center;
}

.payment-editor-footer {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.payment-editor-footer p {
  min-width: 0;
  flex: 1 1 auto;
  margin: 0;
  color: #94a3b8;
  font-size: 8px;
}

.payment-editor-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.event-payment-editor .payment-editor-actions > button {
  min-width: 112px;
  min-height: 36px;
  padding: 0 11px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  background: #7c3aed;
}

.event-payment-editor .payment-editor-actions > button.secondary {
  min-width: 60px;
  border: 1px solid #ddd6fe;
  color: #6d28d9;
  background: #fff;
}

.event-payment-editor .payment-editor-actions > button:disabled {
  cursor: not-allowed;
  color: #94a3b8;
  background: #e8e9ee;
  opacity: 1;
}

.payment-copy-toast {
  position: fixed;
  right: 50%;
  bottom: max(24px, env(safe-area-inset-bottom));
  z-index: 1600;
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  border-radius: 11px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  background: rgba(29, 41, 57, 0.94);
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.24);
  backdrop-filter: blur(8px);
  transform: translateX(50%);
}

.payment-copy-toast svg {
  width: 17px;
  height: 17px;
  color: #c4b5fd;
}

@media (max-width: 640px) {
  .payment-editor-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .payment-editor-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .payment-editor-actions,
  .event-payment-editor .payment-editor-actions > button {
    width: 100%;
  }
  .payment-account-primary {
    gap: 7px;
  }
}`],
})
export class PortalPostListComponent implements OnInit, OnDestroy {
    public loading: boolean = false;
    public list: any[] = [];
    public categories: string[] = [];
    public selectedCategory: string = "";
    public weekdays: string[] = ["일", "월", "화", "수", "목", "금", "토"];
    public months: number[] = Array.from({ length: 12 }, (_, index) => index + 1);
    public yearOptions: number[] = [];
    public calendarYear: number = new Date().getFullYear();
    public calendarMonth: number = new Date().getMonth() + 1;
    public pickerYear: number = new Date().getFullYear();
    public periodPickerOpen: boolean = false;
    public calendarDays: any[] = [];
    public calendarWeeks: any[] = [];
    public selectedDateLabel: string = "";
    public selectedDateKey: string = "";
    public selectedDayItems: any[] = [];
    public selectedEvent: any = null;
    public sidePanelOpen: boolean = false;
    public showPersonalModal: boolean = false;
    public saving: boolean = false;
    public personalData: any = {};
    public personalEditingId: string = '';
    public personalRecurrenceOpen: boolean = true;
    public personalReminderOpen: boolean = true;
    public personalMemoryLoading: boolean = false;
    public personalMemory: any = null;
    public personalMemories: any[] = [];
    public personalMemoryDraft: any = this.emptyPersonalMemory();
    public eventDetailTab: 'schedule' | 'itinerary' | 'memory' | 'expense' = 'schedule';
    public eventAftercareLoading: boolean = false;
    public eventAftercare: any = null;
    public meetingMemoryDraft: any = this.emptyMeetingMemory();
    public expenseDraft: any = this.emptyExpense();
    public paymentInfoDraft: any = this.emptyPaymentInfo();
    public paymentInfoEditing: boolean = false;
    public paymentInfoEditingId: string = '';
    public paymentInfoEditingEntryId: string = '';
    public paymentBankSearch: string = '';
    public paymentBankDropdownOpen: boolean = false;
    public paymentToastMessage: string = '';
    public readonly paymentBankOptions: string[] = [
        'KB국민은행', '신한은행', '우리은행', '하나은행', 'NH농협은행',
        'IBK기업은행', 'SC제일은행', '한국씨티은행', 'Sh수협은행',
        '카카오뱅크', '토스뱅크', '케이뱅크', '부산은행', 'iM뱅크',
        '광주은행', '전북은행', '제주은행', '새마을금고', '신협',
        '우체국', '저축은행', '산림조합'
    ];
    public readonly paymentAccountPatterns: { [key: string]: number[] } = {
        'KB국민은행': [6, 2, 6], '신한은행': [3, 3, 6],
        '우리은행': [4, 3, 6], '하나은행': [3, 6, 5],
        'NH농협은행': [3, 4, 4, 2], 'IBK기업은행': [3, 6, 2, 3],
        'SC제일은행': [3, 2, 6], '한국씨티은행': [3, 5, 3],
        'Sh수협은행': [4, 4, 4], '카카오뱅크': [4, 2, 7],
        '토스뱅크': [4, 4, 4], '케이뱅크': [3, 3, 6],
        '부산은행': [3, 4, 4, 2], 'iM뱅크': [3, 2, 6],
        '광주은행': [3, 3, 6], '전북은행': [3, 4, 4, 2],
        '제주은행': [3, 3, 6], '우체국': [6, 2, 6]
    };
    public lightboxImage: string = '';
    public lightboxAlt: string = '';
    public memoryDropTarget: 'personal' | 'meeting' | '' = '';
    public draggedSchedule: any = null;
    public calendarDropDateKey: string = '';
    public movingScheduleId: string = '';
    public readonly recurrenceOptions: any[] = [
        { value: 'none', label: '반복 안 함' },
        { value: 'daily', label: '매일' },
        { value: 'weekly', label: '매주' },
        { value: 'monthly', label: '매월' },
        { value: 'custom', label: '사용자 지정' }
    ];
    public readonly recurrenceWeekdays: any[] = [
        { value: 0, label: '월' }, { value: 1, label: '화' },
        { value: 2, label: '수' }, { value: 3, label: '목' },
        { value: 4, label: '금' }, { value: 5, label: '토' },
        { value: 6, label: '일' }
    ];
    public readonly reminderOptions: any[] = [
        { value: '10', label: '10분 전' },
        { value: '30', label: '30분 전' },
        { value: '60', label: '1시간 전' },
        { value: '1440', label: '1일 전' },
        { value: 'custom', label: '사용자 지정' }
    ];

    private today: Date = new Date();
    private currentMonth: Date = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
    private panelTriggerKey: string = "";
    private calendarDragAnchorKey: string = '';
    private suppressCalendarClickUntil: number = 0;
    private paymentBankCloseTimer: any = null;
    private paymentToastTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.refreshYearOptions(this.today.getFullYear());
        this.setSelectedDate(this.today);
        await this.loadCategories();
        await this.load();
        if (new URLSearchParams(location.search).get("action") === "personal") {
            await this.openPersonalSchedule();
        }
    }

    public ngOnDestroy() {
        if (this.paymentBankCloseTimer) clearTimeout(this.paymentBankCloseTimer);
        if (this.paymentToastTimer) clearTimeout(this.paymentToastTimer);
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code === 200) {
            this.categories = data;
        }
    }

    public async selectCategory(cat: string) {
        this.periodPickerOpen = false;
        this.selectedCategory = this.selectedCategory === cat ? "" : cat;
        await this.load();
    }

    public async previousMonth() {
        const target = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
        this.periodPickerOpen = false;
        this.closeSidePanelState();
        await this.selectDate(target);
    }

    public async nextMonth() {
        const target = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
        this.periodPickerOpen = false;
        this.closeSidePanelState();
        await this.selectDate(target);
    }

    public async goToday() {
        this.today = new Date();
        this.periodPickerOpen = false;
        this.closeSidePanelState();
        await this.selectDate(this.today);
    }

    public async togglePeriodPicker() {
        this.periodPickerOpen = !this.periodPickerOpen;
        if (this.periodPickerOpen) {
            this.pickerYear = this.calendarYear;
            this.refreshYearOptions(this.pickerYear);
        }
        await this.service.render();
    }

    public async selectCalendarMonth(month: number) {
        const year = Number(this.pickerYear);
        if (!year || month < 1 || month > 12) return;
        this.periodPickerOpen = false;
        this.closeSidePanelState();
        await this.selectDate(new Date(year, month - 1, 1));
    }

    public async selectDay(day: any, event?: Event) {
        if (event) event.stopPropagation();
        this.periodPickerOpen = false;
        const triggerKey = `date:${day.key}`;
        this.sidePanelOpen = true;
        this.panelTriggerKey = triggerKey;
        await this.selectDate(day.date);
        this.revealSidePanelOnMobile();
    }

    public async selectDate(date: Date) {
        this.currentMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        this.setSelectedDate(date);
        this.buildCalendar();
        await this.service.render();
    }

    public canMoveSchedule(item: any) {
        return !!item && (item.is_personal || item.can_edit === true);
    }

    public startScheduleDrag(
        item: any,
        event: DragEvent,
        anchorKey: string = ''
    ) {
        if (!this.canMoveSchedule(item) || this.movingScheduleId) {
            event.preventDefault();
            return;
        }
        this.draggedSchedule = item;
        this.calendarDragAnchorKey = anchorKey || item.occurrenceDateKey
            || this.dateKey(item.scheduleDate);
        this.calendarDropDateKey = '';
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', item.id || '');
        }
        this.service.render();
    }

    public finishScheduleDrag() {
        this.draggedSchedule = null;
        this.calendarDragAnchorKey = '';
        this.calendarDropDateKey = '';
        this.suppressCalendarClickUntil = Date.now() + 300;
        this.service.render();
    }

    public allowScheduleDrop(day: any, event: DragEvent) {
        if (!this.draggedSchedule || this.movingScheduleId) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.calendarDropDateKey === day.key) return;
        this.calendarDropDateKey = day.key;
        this.service.render();
    }

    public leaveScheduleDrop(day: any, event: DragEvent) {
        const current = event.currentTarget as HTMLElement | null;
        const related = event.relatedTarget as Node | null;
        if (current && related && current.contains(related)) return;
        if (this.calendarDropDateKey !== day.key) return;
        this.calendarDropDateKey = '';
        this.service.render();
    }

    public allowScheduleWeekDrop(week: any, event: DragEvent) {
        const day = this.calendarWeekDropDay(week, event);
        if (day) this.allowScheduleDrop(day, event);
    }

    public leaveScheduleWeek(event: DragEvent) {
        const current = event.currentTarget as HTMLElement | null;
        const related = event.relatedTarget as Node | null;
        if (current && related && current.contains(related)) return;
        this.calendarDropDateKey = '';
        this.service.render();
    }

    public async dropScheduleOnWeek(week: any, event: DragEvent) {
        const day = this.calendarWeekDropDay(week, event);
        if (day) await this.dropScheduleOnDay(day, event);
    }

    public async dropScheduleOnDay(day: any, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const schedule = this.draggedSchedule;
        const anchorKey = this.calendarDragAnchorKey;
        this.finishScheduleDrag();
        if (!schedule || !this.canMoveSchedule(schedule)) return;

        const scheduleStart = this.dateOnly(schedule.scheduleDate);
        const anchorDate = this.parseDate(anchorKey);
        const targetDate = this.parseDate(day.key);
        if (!scheduleStart || !anchorDate || !targetDate) return;

        const anchorOffset = this.dayDistance(scheduleStart, anchorDate);
        const targetStart = new Date(
            targetDate.getFullYear(),
            targetDate.getMonth(),
            targetDate.getDate() - anchorOffset
        );
        const dayOffset = this.dayDistance(scheduleStart, targetStart);
        if (dayOffset === 0) return;

        const scheduleAt = this.shiftScheduleDateValue(
            schedule.schedule_at || schedule.scheduleDate,
            dayOffset
        );
        const scheduleEndAt = this.shiftScheduleDateValue(
            schedule.schedule_end_at || schedule.scheduleEndDate
                || schedule.schedule_at || schedule.scheduleDate,
            dayOffset
        );
        if (!scheduleAt || !scheduleEndAt) return;

        this.movingScheduleId = schedule.id;
        await this.service.render();
        const movePayload = {
            id: schedule.id,
            meeting_id: schedule.meeting_id || '',
            is_personal: !!schedule.is_personal,
            schedule_at: scheduleAt,
            schedule_end_at: scheduleEndAt,
            force_save: false
        };
        let response = await wiz.call('move_schedule', movePayload);
        if (response.code === 409) {
            this.movingScheduleId = '';
            await this.service.render();
            const confirmed = await this.service.modal.error(
                this.scheduleConflictMessage(response.data),
                true,
                '그래도 저장'
            );
            if (!confirmed) return;
            this.movingScheduleId = schedule.id;
            await this.service.render();
            response = await wiz.call('move_schedule', {
                ...movePayload,
                force_save: true
            });
        }
        const { code, data } = response;
        this.movingScheduleId = '';
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '일정 날짜를 변경하지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        const moved = this.toScheduleItem({ ...schedule, ...data });
        const index = this.list.findIndex((item: any) => (
            item.id === schedule.id
            && !!item.is_personal === !!schedule.is_personal
        ));
        if (index >= 0) this.list[index] = moved;
        if (this.selectedEvent?.id === schedule.id) this.selectedEvent = moved;
        this.buildCalendar();
        await this.showPaymentToast(`‘${moved.title || '일정'}’ 날짜를 변경했습니다.`);
        await this.service.render();
    }

    public async handleCalendarEventClick(item: any, event: Event) {
        if (Date.now() < this.suppressCalendarClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        await this.openEvent(item, event);
    }

    public async handleCalendarSegmentClick(segment: any, event: Event) {
        await this.handleCalendarEventClick({
            ...segment.schedule,
            occurrenceDateKey: segment.segmentStartKey
        }, event);
    }

    public calendarEventTime(item: any) {
        return item?.scheduleDate
            ? this.formatScheduleTime(item.scheduleDate)
            : '';
    }

    public async openEvent(item: any, event?: Event) {
        if (event) event.stopPropagation();
        this.periodPickerOpen = false;
        const occurrenceDate = this.parseDate(item.occurrenceDateKey) || item.scheduleDate;
        const occurrenceKey = occurrenceDate ? this.dateKey(occurrenceDate) : this.selectedDateKey;
        const triggerKey = `event:${item.id || item.title}:${occurrenceKey}`;

        if (this.sidePanelOpen && this.panelTriggerKey === triggerKey) {
            this.closeSidePanelState();
        } else {
            this.sidePanelOpen = true;
            this.panelTriggerKey = triggerKey;
            if (occurrenceDate) {
                this.currentMonth = new Date(occurrenceDate.getFullYear(), occurrenceDate.getMonth(), 1);
                this.setSelectedDate(occurrenceDate);
                this.buildCalendar();
            }
        }
        this.selectedEvent = item;
        this.eventDetailTab = 'schedule';
        this.personalMemory = null;
        this.personalMemories = [];
        this.personalMemoryLoading = false;
        this.personalMemoryDraft = this.emptyPersonalMemory();
        this.eventAftercare = null;
        this.eventAftercareLoading = false;
        this.meetingMemoryDraft = this.emptyMeetingMemory();
        this.expenseDraft = this.emptyExpense();
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentBankSearch = '';
        this.paymentBankDropdownOpen = false;
        await this.service.render();
        if (item?.is_personal && item?.is_past) {
            await this.loadPersonalMemory();
        } else if (!item?.is_personal && item?.is_past) {
            await this.loadEventAftercare();
        }
    }

    public async closeSidePanel() {
        this.closeSidePanelState();
        await this.service.render();
    }

    public async closeEvent() {
        this.selectedEvent = null;
        this.personalMemory = null;
        this.personalMemories = [];
        this.personalMemoryLoading = false;
        this.eventAftercare = null;
        this.eventAftercareLoading = false;
        this.eventDetailTab = 'schedule';
        this.lightboxImage = '';
        this.lightboxAlt = '';
        await this.service.render();
    }

    public async loadPersonalMemory() {
        if (!this.selectedEvent?.is_personal || !this.selectedEvent?.is_past) {
            return;
        }
        const scheduleId = this.selectedEvent.id;
        this.personalMemoryLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("personal_memory", {
            id: scheduleId
        });
        if (this.selectedEvent?.id !== scheduleId) return;
        this.personalMemoryLoading = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, "추억을 불러오지 못했습니다.")
            );
            await this.service.render();
            return;
        }
        this.applyPersonalMemory(data);
        await this.service.render();
    }

    public async choosePersonalMemoryPhoto() {
        if (this.personalMemoryDraft.photos.length >= 4 || this.saving) return;
        const image = await this.service.file.read({
            type: "image",
            accept: "image/*",
            width: 960,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 1800000) {
            await this.service.modal.error(
                "사진 한 장은 1.3MB 이하로 올려주세요."
            );
            return;
        }
        this.personalMemoryDraft.photos.push(image);
        await this.service.render();
    }

    public async selectMemoryPhotos(
        event: any,
        target: 'personal' | 'meeting'
    ) {
        const input = event?.target as HTMLInputElement;
        await this.addMemoryPhotos(
            Array.from(input?.files || []) as File[],
            target
        );
        if (input) input.value = '';
    }

    public async handleMemoryDragOver(
        event: DragEvent,
        target: 'personal' | 'meeting'
    ) {
        event.preventDefault();
        if (this.saving) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        this.memoryDropTarget = target;
        await this.service.render();
    }

    public async handleMemoryDragLeave(
        event: DragEvent,
        target: 'personal' | 'meeting'
    ) {
        event.preventDefault();
        if (this.memoryDropTarget === target) this.memoryDropTarget = '';
        await this.service.render();
    }

    public async dropMemoryPhotos(
        event: DragEvent,
        target: 'personal' | 'meeting'
    ) {
        event.preventDefault();
        this.memoryDropTarget = '';
        if (this.saving) return;
        await this.addMemoryPhotos(
            Array.from(event.dataTransfer?.files || []) as File[],
            target
        );
    }

    public removePersonalMemoryPhoto(index: number) {
        this.personalMemoryDraft.photos.splice(index, 1);
        this.service.render();
    }

    public async savePersonalMemory() {
        if (this.saving) return;
        if (!this.selectedEvent?.is_personal || !this.selectedEvent?.is_past) {
            await this.service.modal.error(
                '종료된 개인 일정에서만 추억을 저장할 수 있습니다.'
            );
            return;
        }
        if (
            !String(this.personalMemoryDraft.review || '').trim()
            && this.personalMemoryDraft.photos.length === 0
        ) {
            await this.service.modal.error('사진이나 후기를 하나 이상 남겨주세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call("save_personal_memory", {
            id: this.selectedEvent.id,
            review: this.personalMemoryDraft.review,
            photos: JSON.stringify(this.personalMemoryDraft.photos)
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, "추억을 저장하지 못했습니다.")
            );
            await this.service.render();
            return;
        }
        this.applyPersonalMemory(data);
        this.personalMemoryDraft = this.emptyPersonalMemory();
        this.syncSelectedEventMemoryPreview(this.personalMemories);
        await this.service.modal.success("개인 일정의 추억을 저장했습니다.");
        await this.service.render();
    }

    public async deletePersonalMemory(memory: any) {
        if (!memory?.id || this.saving) return;
        const confirmed = await this.service.modal.error(
            "이 일정에 남긴 사진과 후기를 삭제할까요?",
            true,
            "삭제"
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call("delete_personal_memory", {
            id: this.selectedEvent.id,
            memory_id: memory.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, "추억을 삭제하지 못했습니다.")
            );
            await this.service.render();
            return;
        }
        this.applyPersonalMemory(data);
        this.syncSelectedEventMemoryPreview(this.personalMemories);
        await this.service.modal.success("추억을 삭제했습니다.");
        await this.service.render();
    }

    public async setEventDetailTab(
        tab: 'schedule' | 'itinerary' | 'memory' | 'expense'
    ) {
        if (!['schedule', 'itinerary', 'memory', 'expense'].includes(tab)) return;
        if (this.selectedEvent?.is_personal && ['itinerary', 'expense'].includes(tab)) {
            return;
        }
        this.eventDetailTab = tab;
        await this.service.render();
        if (tab === 'memory' && this.selectedEvent?.is_personal
            && this.selectedEvent?.is_past && !this.personalMemoryLoading) {
            if (this.personalMemories.length === 0) await this.loadPersonalMemory();
        }
        if (['memory', 'expense'].includes(tab)
            && !this.selectedEvent?.is_personal
            && this.selectedEvent?.is_past
            && !this.eventAftercare && !this.eventAftercareLoading) {
            await this.loadEventAftercare();
        }
    }

    public async loadEventAftercare() {
        if (!this.selectedEvent?.meeting_id || !this.selectedEvent?.is_past) return;
        const scheduleId = this.selectedEvent.id;
        this.eventAftercareLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('schedule_aftercare', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: scheduleId
        });
        if (this.selectedEvent?.id !== scheduleId) return;
        this.eventAftercareLoading = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '추억과 더치페이를 불러오지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        await this.service.render();
    }

    public async chooseMeetingMemoryPhoto() {
        if (this.meetingMemoryDraft.photos.length >= 4 || this.saving) return;
        const image = await this.service.file.read({
            type: 'image',
            accept: 'image/*',
            width: 960,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 1800000) {
            await this.service.modal.error('사진 한 장은 1.3MB 이하로 올려주세요.');
            return;
        }
        this.meetingMemoryDraft.photos.push(image);
        await this.service.render();
    }

    public removeMeetingMemoryPhoto(index: number) {
        this.meetingMemoryDraft.photos.splice(index, 1);
        this.service.render();
    }

    public async saveEventMemory() {
        if (this.saving) return;
        if (!this.selectedEvent?.id || !this.eventAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 추억을 저장할 수 있습니다.'
            );
            return;
        }
        if (!String(this.meetingMemoryDraft.review || '').trim()
            && this.meetingMemoryDraft.photos.length === 0) {
            await this.service.modal.error('사진이나 후기를 하나 이상 남겨주세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_schedule_memory', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: this.selectedEvent.id,
            review: this.meetingMemoryDraft.review,
            visibility: this.meetingMemoryDraft.visibility,
            photos: JSON.stringify(this.meetingMemoryDraft.photos)
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '추억을 저장하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        this.meetingMemoryDraft = this.emptyMeetingMemory();
        this.syncSelectedEventMemoryPreview(data.memories || []);
        await this.service.modal.success('일정의 추억을 저장했습니다.');
        await this.service.render();
    }

    public async deleteEventMemory(memory: any) {
        if (!memory?.is_mine || this.saving) return;
        const confirmed = await this.service.modal.error(
            '이 추억을 삭제할까요?', true, '삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_schedule_memory', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: this.selectedEvent.id,
            memory_id: memory.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '추억을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        this.syncSelectedEventMemoryPreview(data.memories || []);
        await this.service.render();
    }

    public async addEventExpense() {
        if (this.saving) return;
        if (!this.selectedEvent?.id || !this.eventAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 지출 내역을 추가할 수 있습니다.'
            );
            return;
        }
        if (!String(this.expenseDraft.title || '').trim()) {
            await this.service.modal.error('지출 내용을 입력해주세요.');
            return;
        }
        if (Number(this.expenseDraft.amount) <= 0) {
            await this.service.modal.error('금액을 1원 이상 입력해주세요.');
            return;
        }
        if (!this.expenseDraft.payer_id) {
            await this.service.modal.error('결제한 사람을 선택해주세요.');
            return;
        }
        if (!this.expenseDraft.participant_ids.length) {
            await this.service.modal.error('나눠 낼 사람을 한 명 이상 선택해주세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_schedule_expense', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: this.selectedEvent.id,
            title: this.expenseDraft.title,
            amount: this.expenseDraft.amount,
            payer_id: this.expenseDraft.payer_id,
            participant_ids: JSON.stringify(
                this.expenseDraft.participant_ids
            )
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '지출 내역을 추가하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        this.expenseDraft = this.emptyExpense();
        this.setDefaultExpensePayer();
        await this.service.render();
    }

    public filteredPaymentBanks() {
        const query = String(this.paymentBankSearch || '')
            .trim()
            .toLocaleLowerCase('ko-KR');
        if (
            !query
            || query === String(this.paymentInfoDraft.bank_name || '')
                .toLocaleLowerCase('ko-KR')
        ) return this.paymentBankOptions;
        return this.paymentBankOptions.filter((bank: string) =>
            bank.toLocaleLowerCase('ko-KR').includes(query)
        );
    }

    public openPaymentBankOptions() {
        if (this.paymentBankCloseTimer) {
            clearTimeout(this.paymentBankCloseTimer);
            this.paymentBankCloseTimer = null;
        }
        this.paymentBankDropdownOpen = true;
        this.service.render();
    }

    public togglePaymentBankOptions(event?: Event) {
        if (event) event.preventDefault();
        if (this.paymentBankDropdownOpen) {
            this.closePaymentBankOptions();
            return;
        }
        this.openPaymentBankOptions();
    }

    public closePaymentBankOptions(event?: Event) {
        if (event) event.preventDefault();
        if (this.paymentBankCloseTimer) {
            clearTimeout(this.paymentBankCloseTimer);
            this.paymentBankCloseTimer = null;
        }
        this.paymentBankDropdownOpen = false;
        this.service.render();
    }

    public deferClosePaymentBankOptions() {
        if (this.paymentBankCloseTimer) clearTimeout(this.paymentBankCloseTimer);
        this.paymentBankCloseTimer = setTimeout(() => {
            this.paymentBankDropdownOpen = false;
            this.paymentBankCloseTimer = null;
            this.service.render();
        }, 120);
    }

    public updatePaymentBankSearch(value: string) {
        this.paymentBankSearch = String(value || '');
        const exactBank = this.paymentBankOptions.find(
            (bank: string) => bank === this.paymentBankSearch.trim()
        ) || '';
        this.paymentInfoDraft.bank_name = exactBank;
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            this.paymentInfoDraft.account_number, exactBank
        );
        this.paymentBankDropdownOpen = true;
        this.service.render();
    }

    public selectPaymentBank(bankName: string) {
        if (!this.paymentBankOptions.includes(bankName)) return;
        this.paymentInfoDraft.bank_name = bankName;
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            this.paymentInfoDraft.account_number, bankName
        );
        this.paymentBankSearch = bankName;
        this.paymentBankDropdownOpen = false;
        this.service.render();
    }

    public selectFirstFilteredPaymentBank(event: KeyboardEvent) {
        if (this.paymentBankSearch.trim() === this.paymentInfoDraft.bank_name) {
            event.preventDefault();
            this.paymentBankDropdownOpen = false;
            this.service.render();
            return;
        }
        const bankName = this.filteredPaymentBanks()[0];
        if (!this.paymentBankDropdownOpen || !bankName) return;
        event.preventDefault();
        this.selectPaymentBank(bankName);
    }

    public updatePaymentAccountNumber(value: string) {
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            value, this.paymentInfoDraft.bank_name
        );
        this.service.render();
    }

    public sanitizePaymentAccountInput(event: Event) {
        const input = event.target as HTMLInputElement;
        const formatted = this.formatPaymentAccountNumber(
            input?.value || '', this.paymentInfoDraft.bank_name
        );
        if (input && input.value !== formatted) input.value = formatted;
        this.paymentInfoDraft.account_number = formatted;
        this.service.render();
    }

    public restrictPaymentAccountKeydown(event: KeyboardEvent) {
        if (event.ctrlKey || event.metaKey) return;
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
            'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Enter'
        ];
        if (allowedKeys.includes(event.key)) return;
        if (/^[0-9]$/.test(event.key)) return;
        event.preventDefault();
    }

    public restrictPaymentAccountBeforeInput(event: InputEvent) {
        if (
            event.inputType.startsWith('delete')
            || event.inputType.startsWith('history')
        ) return;
        if (event.data !== null && !/^\d+$/.test(event.data)) {
            event.preventDefault();
        }
    }

    public restrictPaymentAccountPaste(event: ClipboardEvent) {
        const text = event.clipboardData?.getData('text') || '';
        if (!/^\d+$/.test(text)) event.preventDefault();
    }

    public restrictPaymentAccountDrop(event: DragEvent) {
        const text = event.dataTransfer?.getData('text') || '';
        if (!/^\d+$/.test(text)) event.preventDefault();
    }

    public paymentAccountDigits(value: any = null) {
        const target = value === null
            ? this.paymentInfoDraft.account_number
            : value;
        return String(target || '').replace(/\D/g, '').slice(0, 20);
    }

    public formatPaymentAccountNumber(value: any, bankName: string = '') {
        const digits = this.paymentAccountDigits(value);
        if (!digits) return '';
        const pattern = this.paymentAccountPatterns[bankName]
            || [4, 4, 4, 4, 4];
        const groups: string[] = [];
        let offset = 0;
        for (const size of pattern) {
            if (offset >= digits.length) break;
            groups.push(digits.slice(offset, offset + size));
            offset += size;
        }
        if (offset < digits.length) groups.push(digits.slice(offset));
        return groups.filter((group: string) => !!group).join('-');
    }

    public paymentInfoAccountLabel(info: any) {
        if (info?.formatted_account_number) return info.formatted_account_number;
        if (info?.account_number) {
            return this.formatPaymentAccountNumber(
                info.account_number, info.bank_name || ''
            );
        }
        const editValue = this.paymentInfoEditValue(info);
        if (editValue.account_number) return editValue.account_number;
        return info?.content || '기존 송금 정보를 다시 등록해주세요.';
    }

    public paymentInfoBankLabel(info: any) {
        return this.paymentInfoEditValue(info).bank_name
            || '기존 송금 정보';
    }

    public paymentInfoFormValid() {
        return this.paymentBankOptions.includes(
            this.paymentInfoDraft.bank_name
        ) && this.paymentAccountDigits().length >= 8;
    }

    private parsePaymentBundle(content: any) {
        try {
            const payload = JSON.parse(String(content || ''));
            if (payload?.v !== 1 || !Array.isArray(payload?.a)) return [];
            return payload.a
                .filter((entry: any) => Array.isArray(entry) && entry.length >= 3)
                .map((entry: any) => ({
                    id: String(entry[0] || ''),
                    bank_name: String(entry[1] || ''),
                    account_number: this.paymentAccountDigits(entry[2] || '')
                }))
                .filter((entry: any) =>
                    !!entry.id
                    && this.paymentBankOptions.includes(entry.bank_name)
                    && entry.account_number.length >= 8
                );
        } catch (error) {
            return [];
        }
    }

    private paymentEntryId() {
        return `${Date.now().toString(36)}${Math.random()
            .toString(36).slice(2, 7)}`;
    }

    private ownPaymentEntries(excludedId: string = '') {
        return (this.eventAftercare?.payment_infos || [])
            .filter((info: any) => info.is_mine && info.id !== excludedId)
            .map((info: any) => {
                const value = this.paymentInfoEditValue(info);
                return {
                    id: String(info.bundle_entry_id || info.id || ''),
                    bank_name: value.bank_name,
                    account_number: this.paymentAccountDigits(
                        value.account_number
                    )
                };
            })
            .filter((entry: any) =>
                !!entry.id
                && this.paymentBankOptions.includes(entry.bank_name)
                && entry.account_number.length >= 8
            );
    }

    private encodePaymentEntries(entries: any[]) {
        return JSON.stringify({
            v: 1,
            a: entries.map((entry: any) => [
                entry.id, entry.bank_name, entry.account_number
            ])
        });
    }

    public paymentInfoContent() {
        const bankName = String(this.paymentInfoDraft.bank_name || '').trim();
        const accountNumber = this.paymentAccountDigits();
        const editingInfo = this.paymentInfoEditing
            ? (this.eventAftercare?.payment_infos || []).find(
                (info: any) => info.id === this.paymentInfoEditingEntryId
            )
            : null;
        const entries = this.ownPaymentEntries(
            this.paymentInfoEditing ? this.paymentInfoEditingEntryId : ''
        );
        entries.push({
            id: this.paymentInfoEditing
                ? String(
                    editingInfo?.bundle_entry_id
                    || editingInfo?.id
                    || this.paymentInfoEditingEntryId
                )
                : this.paymentEntryId(),
            bank_name: bankName,
            account_number: accountNumber
        });
        return this.encodePaymentEntries(entries);
    }

    public paymentDestinationLabel(value: any) {
        const entries = this.parsePaymentBundle(value);
        if (!entries.length) return String(value || '');
        const account = entries[entries.length - 1];
        return `${account.bank_name} ${this.formatPaymentAccountNumber(
            account.account_number, account.bank_name
        )}`;
    }

    public paymentInfoChanged() {
        if (!this.paymentInfoEditing) return true;
        const saved = (this.eventAftercare?.payment_infos || []).find(
            (info: any) => info.id === this.paymentInfoEditingEntryId
                && info.is_mine
        );
        if (!saved) return false;
        const savedValue = this.paymentInfoEditValue(saved);
        return String(savedValue.bank_name || '')
            !== String(this.paymentInfoDraft.bank_name || '')
            || this.paymentAccountDigits(savedValue.account_number || '')
            !== this.paymentAccountDigits();
    }

    public canSavePaymentInfo() {
        return !this.saving
            && this.paymentInfoFormValid()
            && this.paymentInfoChanged();
    }

    public paymentInfoEditValue(info: any) {
        let bankName = String(info?.bank_name || '').trim();
        let accountNumber = this.paymentAccountDigits(
            info?.account_number || ''
        );
        if (!bankName || !accountNumber) {
            const content = String(info?.content || '').trim();
            const legacyBank = [...this.paymentBankOptions]
                .sort((left: string, right: string) => right.length - left.length)
                .find((bank: string) => content.startsWith(bank)) || '';
            if (legacyBank) {
                bankName = legacyBank;
                accountNumber = this.paymentAccountDigits(
                    content.slice(legacyBank.length)
                );
            }
        }
        return {
            bank_name: bankName,
            account_number: this.formatPaymentAccountNumber(
                accountNumber, bankName
            )
        };
    }

    public async editEventPaymentInfo(info: any) {
        if (!info?.is_mine || !info?.id || this.saving) return;
        const editValue = this.paymentInfoEditValue(info);
        this.paymentInfoEditing = true;
        this.paymentInfoEditingId = String(info.storage_id || info.id || '');
        this.paymentInfoEditingEntryId = String(info.id || '');
        this.paymentInfoDraft = editValue;
        this.paymentBankSearch = editValue.bank_name;
        this.paymentBankDropdownOpen = false;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('event-payment-editor-title')
                ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 0);
    }

    public cancelEventPaymentInfoEdit() {
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentBankSearch = '';
        this.closePaymentBankOptions();
    }

    public async copyEventPaymentAccount(info: any) {
        const editValue = this.paymentInfoEditValue(info);
        const accountNumber = editValue.account_number
            ? this.paymentAccountDigits(editValue.account_number)
            : String(info?.content || '').trim();
        if (!accountNumber) return;
        try {
            await this.writeClipboard(accountNumber);
            await this.showPaymentToast('계좌번호를 복사했습니다.');
        } catch (error) {
            await this.showPaymentToast('계좌번호를 복사하지 못했습니다.');
        }
    }

    public async saveEventPaymentInfo() {
        if (this.saving) return;
        if (!this.selectedEvent?.id || !this.eventAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 송금 정보를 등록할 수 있습니다.'
            );
            return;
        }
        if (!this.paymentInfoDraft.bank_name) {
            await this.service.modal.error('은행을 목록에서 선택해주세요.');
            return;
        }
        if (this.paymentAccountDigits().length < 8) {
            await this.service.modal.error('계좌번호를 8자리 이상 입력해주세요.');
            return;
        }
        if (!this.paymentInfoChanged()) return;
        if (!this.paymentInfoEditing && this.ownPaymentEntries().length >= 16) {
            await this.service.modal.error(
                '송금 정보는 한 일정에 최대 16개까지 등록할 수 있습니다.'
            );
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_schedule_payment_info', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: this.selectedEvent.id,
            bank_name: this.paymentInfoDraft.bank_name,
            account_number: this.paymentAccountDigits(),
            payment_info_id: this.paymentInfoEditingId,
            content: this.paymentInfoContent()
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '송금 정보를 저장하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        const successMessage = this.paymentInfoEditing
            ? '송금 정보를 수정했습니다.'
            : '송금 정보를 추가했습니다.';
        this.applyEventAftercare(data);
        await this.service.modal.success(successMessage);
        await this.service.render();
    }

    public async deleteEventPaymentInfo(info: any) {
        if (!info?.is_mine || !info?.id || this.saving) return;
        const confirmed = await this.service.modal.error(
            '등록한 송금 정보를 삭제할까요?', true, '삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        let response: any;
        if (info.is_bundle_entry) {
            const remaining = this.ownPaymentEntries(info.id);
            if (remaining.length) {
                const account = remaining[0];
                response = await wiz.call('save_schedule_payment_info', {
                    meeting_id: this.selectedEvent.meeting_id,
                    schedule_id: this.selectedEvent.id,
                    bank_name: account.bank_name,
                    account_number: account.account_number,
                    payment_info_id: info.storage_id,
                    content: this.encodePaymentEntries(remaining)
                });
            } else {
                response = await wiz.call('delete_schedule_payment_info', {
                    meeting_id: this.selectedEvent.meeting_id,
                    schedule_id: this.selectedEvent.id,
                    payment_info_id: info.storage_id
                });
            }
        } else {
            response = await wiz.call('delete_schedule_payment_info', {
                meeting_id: this.selectedEvent.meeting_id,
                schedule_id: this.selectedEvent.id,
                payment_info_id: info.storage_id || info.id
            });
        }
        const { code, data } = response;
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '송금 정보를 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        await this.service.render();
    }

    public async deleteEventExpense(expense: any) {
        if (!expense?.can_delete || this.saving) return;
        const confirmed = await this.service.modal.error(
            `‘${expense.title}’ 지출을 삭제할까요?`, true, '삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_schedule_expense', {
            meeting_id: this.selectedEvent.meeting_id,
            schedule_id: this.selectedEvent.id,
            expense_id: expense.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '지출 내역을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyEventAftercare(data);
        await this.service.render();
    }

    public formatWon(value: any) {
        return `${Math.max(0, Number(value) || 0).toLocaleString('ko-KR')}원`;
    }

    public initial(value: any) {
        return Array.from(String(value || '').trim())[0] || '?';
    }

    public isExpenseParticipantSelected(userId: string) {
        return (this.expenseDraft.participant_ids || []).includes(userId);
    }

    public async toggleExpenseParticipant(userId: string) {
        const selected = [...(this.expenseDraft.participant_ids || [])];
        const index = selected.indexOf(userId);
        if (index >= 0) selected.splice(index, 1);
        else selected.push(userId);
        this.expenseDraft.participant_ids = selected;
        await this.service.render();
    }

    public openImageLightbox(image: string, alt: string = '추억 사진') {
        if (!image) return;
        this.lightboxImage = image;
        this.lightboxAlt = alt;
        this.service.render();
    }

    public closeImageLightbox() {
        this.lightboxImage = '';
        this.lightboxAlt = '';
        this.service.render();
    }

    public async openPersonalSchedule(date?: Date, event?: Event) {
        if (event) event.stopPropagation();
        this.periodPickerOpen = false;
        this.personalEditingId = '';
        this.personalRecurrenceOpen = true;
        this.personalReminderOpen = true;
        this.personalData = this.emptyPersonalSchedule(date);
        this.showPersonalModal = true;
        await this.service.render();
    }

    public async editPersonalSchedule() {
        const schedule = this.selectedEvent;
        if (!schedule?.is_personal || this.saving) return;
        this.personalEditingId = schedule.id;
        this.personalRecurrenceOpen = true;
        this.personalReminderOpen = true;
        const rule = schedule.recurrence_rule || { frequency: 'none' };
        const reminders = Array.isArray(schedule.reminders)
            ? schedule.reminders : [];
        this.personalData = {
            title: schedule.title || '',
            schedule_at: schedule.scheduleDate
                ? this.toDateTimeInput(schedule.scheduleDate)
                : '',
            schedule_end_at: schedule.scheduleEndDate
                ? this.toDateTimeInput(schedule.scheduleEndDate)
                : '',
            place: schedule.place || '',
            description: schedule.description || schedule.content || '',
            recurrence_id: schedule.recurrence_id || '',
            recurrence_frequency: rule.frequency || 'none',
            recurrence_interval: Number(rule.interval || 1),
            recurrence_weekdays: [...(rule.weekdays || [])],
            recurrence_end_type: rule.end_type || 'count',
            recurrence_end_date: rule.end_date || '',
            recurrence_count: Number(rule.count || 10),
            edit_scope: 'this',
            reminder_enabled: reminders.length > 0,
            reminders: reminders.length
                ? reminders.map((item: any) => this.reminderDraft(item.minutes))
                : [this.reminderDraft(30)]
        };
        this.selectedEvent = null;
        this.eventDetailTab = 'schedule';
        this.showPersonalModal = true;
        await this.service.render();
    }

    public async closePersonalSchedule() {
        if (this.saving) return;
        this.showPersonalModal = false;
        this.personalEditingId = '';
        await this.service.render();
    }

    public async savePersonalSchedule() {
        if (!String(this.personalData.title || "").trim()) {
            await this.service.modal.error("일정명을 입력해주세요.");
            return;
        }
        if (!this.personalData.schedule_at || !this.personalData.schedule_end_at) {
            await this.service.modal.error("시작·종료 일시를 선택해주세요.");
            return;
        }
        if (this.personalData.schedule_end_at < this.personalData.schedule_at) {
            await this.service.modal.error("종료 일시는 시작 일시보다 빠를 수 없습니다.");
            return;
        }

        if (this.personalData.recurrence_frequency === 'custom'
            && !(this.personalData.recurrence_weekdays || []).length) {
            await this.service.modal.error('반복할 요일을 하나 이상 선택해주세요.');
            return;
        }
        const editing = !!this.personalEditingId;
        const payload = this.personalSchedulePayload(false);
        this.saving = true;
        await this.service.render();
        let response = await wiz.call(
            editing ? "update_personal" : "create_personal",
            editing
                ? { id: this.personalEditingId, ...payload }
                : payload
        );
        if (response.code === 409) {
            this.saving = false;
            await this.service.render();
            const confirmed = await this.service.modal.error(
                this.scheduleConflictMessage(response.data),
                true,
                '그래도 저장'
            );
            if (!confirmed) return;
            this.saving = true;
            await this.service.render();
            response = await wiz.call(
                editing ? "update_personal" : "create_personal",
                editing
                    ? { id: this.personalEditingId, ...this.personalSchedulePayload(true) }
                    : this.personalSchedulePayload(true)
            );
        }
        const { code, data } = response;
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(
                data,
                editing
                    ? "개인 일정을 수정하지 못했습니다."
                    : "개인 일정을 추가하지 못했습니다."
            ));
            await this.service.render();
            return;
        }

        const targetDate = this.parseDate(data?.schedule_at || this.personalData.schedule_at);
        this.showPersonalModal = false;
        this.personalEditingId = '';
        this.selectedCategory = "";
        await this.loadCategories();
        await this.load();
        if (targetDate) await this.selectDate(targetDate);
        await this.service.modal.success(
            editing
                ? "개인 일정이 수정되었습니다."
                : "개인 일정이 추가되었습니다."
        );
    }

    public async togglePersonalRecurrenceWeekday(value: number) {
        const weekdays = [...(this.personalData.recurrence_weekdays || [])];
        const index = weekdays.indexOf(value);
        if (index >= 0) weekdays.splice(index, 1);
        else weekdays.push(value);
        this.personalData.recurrence_weekdays = weekdays.sort();
        await this.service.render();
    }

    public async togglePersonalRecurrenceSection() {
        this.personalRecurrenceOpen = !this.personalRecurrenceOpen;
        await this.service.render();
    }

    public async togglePersonalReminderSection() {
        this.personalReminderOpen = !this.personalReminderOpen;
        await this.service.render();
    }

    public async setPersonalRecurrenceFrequency(value: string) {
        this.personalData.recurrence_frequency = value;
        await this.service.render();
    }

    public async setPersonalReminderPreset(index: number, value: string) {
        const reminder = (this.personalData.reminders || [])[index];
        if (!reminder) return;
        this.personalData.reminder_enabled = true;
        reminder.preset = value;
        if (value !== 'custom') reminder.custom_minutes = Number(value);
        await this.service.render();
    }

    public async disablePersonalReminder() {
        this.personalData.reminder_enabled = false;
        this.personalData.reminders = [this.reminderDraft(30)];
        await this.service.render();
    }

    public personalRecurrenceWeekdaySelected(value: number) {
        return (this.personalData.recurrence_weekdays || []).includes(value);
    }

    public async addPersonalReminder() {
        if (!this.personalData.reminder_enabled
            || (this.personalData.reminders || []).length >= 5) return;
        const used = new Set(
            (this.personalData.reminders || []).map(
                (item: any) => item.preset === 'custom'
                    ? Number(item.custom_minutes) : Number(item.preset)
            )
        );
        const nextMinutes = [10, 30, 60, 1440, 120].find(
            (minutes: number) => !used.has(minutes)
        ) || 120;
        this.personalData.reminders.push(this.reminderDraft(nextMinutes));
        await this.service.render();
    }

    public async removePersonalReminder(index: number) {
        if (index <= 0) return;
        this.personalData.reminders.splice(index, 1);
        await this.service.render();
    }

    public async deletePersonalSchedule() {
        if (!this.selectedEvent?.is_personal || this.saving) return;
        const confirmed = await this.service.modal.error(
            "이 개인 일정을 삭제할까요?",
            true,
            "삭제"
        );
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call("delete_personal", {
            id: this.selectedEvent.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, "개인 일정을 삭제하지 못했습니다."));
            await this.service.render();
            return;
        }

        this.selectedEvent = null;
        await this.loadCategories();
        await this.load();
        await this.service.modal.success("개인 일정이 삭제되었습니다.");
    }

    public async load() {
        if (this.loading) return;
        this.loading = true;
        this.list = [];
        this.buildCalendar();
        await this.service.render();

        const { code, data } = await wiz.call("search", {
            category: this.selectedCategory
        });

        if (code === 200) {
            this.list = (data.rows || [])
                .map((item: any) => this.toScheduleItem(item))
                .filter((item: any) => item.scheduleDate)
                .sort((left: any, right: any) => left.scheduleDate.getTime() - right.scheduleDate.getTime());
            this.buildCalendar();
            this.syncSelectedDay();
        }

        this.loading = false;
        await this.service.render();
    }

    public trackByDay(index: number, day: any) {
        return day.key;
    }

    public trackByWeek(index: number, week: any) {
        return week.key;
    }

    public trackByCalendarSegment(index: number, segment: any) {
        return segment.key;
    }

    private buildCalendar() {
        this.calendarYear = this.currentMonth.getFullYear();
        this.calendarMonth = this.currentMonth.getMonth() + 1;
        this.pickerYear = this.calendarYear;
        this.refreshYearOptions(this.calendarYear);

        const first = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1);
        const start = new Date(first);
        start.setDate(first.getDate() - first.getDay());

        const days = [];
        for (let index = 0; index < 42; index++) {
            const date = new Date(start);
            date.setDate(start.getDate() + index);
            const key = this.dateKey(date);
            days.push({
                key,
                date,
                inMonth: date.getMonth() === this.currentMonth.getMonth(),
                isToday: key === this.dateKey(this.today),
                selected: key === this.selectedDateKey,
                items: this.itemsForDate(date)
            });
        }

        this.calendarDays = days;
        const weeks = [];
        for (let weekIndex = 0; weekIndex < 6; weekIndex++) {
            const weekDays = days.slice(weekIndex * 7, weekIndex * 7 + 7);
            const weekStart = this.dateOnly(weekDays[0].date) as Date;
            const weekEnd = this.dateOnly(weekDays[6].date) as Date;
            const segments: any[] = [];

            this.list.forEach((schedule: any) => {
                const scheduleStart = this.dateOnly(schedule.scheduleDate);
                const scheduleEnd = this.dateOnly(
                    schedule.scheduleEndDate || schedule.scheduleDate
                );
                if (
                    !scheduleStart
                    || !scheduleEnd
                    || scheduleEnd < weekStart
                    || scheduleStart > weekEnd
                ) return;

                const segmentStart = scheduleStart < weekStart
                    ? weekStart
                    : scheduleStart;
                const segmentEnd = scheduleEnd > weekEnd
                    ? weekEnd
                    : scheduleEnd;
                const startColumn = this.dayDistance(
                    weekStart, segmentStart
                ) + 1;
                const span = this.dayDistance(segmentStart, segmentEnd) + 1;
                segments.push({
                    key: `${schedule.id}-${weekDays[0].key}`,
                    schedule,
                    startColumn,
                    endColumn: startColumn + span - 1,
                    span,
                    segmentStartKey: this.dateKey(segmentStart),
                    gridColumn: `${startColumn} / span ${span}`,
                    lane: 1
                });
            });

            segments.sort((left: any, right: any) => {
                if (left.startColumn !== right.startColumn) {
                    return left.startColumn - right.startColumn;
                }
                return right.span - left.span;
            });
            const laneEnds: number[] = [];
            segments.forEach((segment: any) => {
                let lane = laneEnds.findIndex(
                    (endColumn: number) => segment.startColumn > endColumn
                );
                if (lane < 0) {
                    lane = laneEnds.length;
                    laneEnds.push(segment.endColumn);
                } else {
                    laneEnds[lane] = segment.endColumn;
                }
                segment.lane = lane + 1;
            });
            weeks.push({
                key: weekDays[0].key,
                days: weekDays,
                segments,
                minHeight: Math.max(108, 42 + laneEnds.length * 33)
            });
        }
        this.calendarWeeks = weeks;
        this.syncSelectedDay();
    }

    private toScheduleItem(item: any) {
        const scheduleDate = this.getScheduleDate(item);
        const scheduleEndDate = this.parseDate(item.schedule_end_at) || scheduleDate;
        const createdDate = this.parseDate(item.created);
        return {
            ...item,
            category: item.meeting_name || item.category || "",
            content: item.description || item.content || "",
            displayAuthor: item.creator_name || item.author_name || item.author || "",
            displayPlace: item.place || "",
            createdLabel: createdDate ? this.formatScheduleFullDate(createdDate) : (item.created || ""),
            scheduleDate,
            scheduleEndDate,
            scheduleDateLabel: scheduleDate
                ? (item.all_day ? "종일" : this.formatScheduleTime(scheduleDate))
                : "",
            scheduleFullDateLabel: scheduleDate
                ? (
                    item.all_day
                        ? this.formatAllDayScheduleRange(
                            scheduleDate, scheduleEndDate
                        )
                        : this.formatScheduleRange(
                            scheduleDate, scheduleEndDate
                        )
                )
                : ""
        };
    }

    private getScheduleDate(item: any) {
        const dateKeys = ["schedule_at", "schedule_date", "scheduled_at", "event_date", "start_date", "start_at", "confirmed_at", "date"];
        for (let key of dateKeys) {
            const parsed = this.parseDate(item[key]);
            if (parsed) return parsed;
        }

        return this.extractDate(item.title) || this.extractDate(item.content) || this.parseDate(item.created);
    }

    private extractDate(text: string) {
        if (!text) return null;
        const matched = String(text).match(/(\d{4})[-./년\s]+(\d{1,2})[-./월\s]+(\d{1,2})/);
        if (!matched) return null;
        return this.parseDate(`${matched[1]}-${matched[2]}-${matched[3]}`);
    }

    private parseDate(value: any) {
        if (!value) return null;
        if (value instanceof Date && !isNaN(value.getTime())) return value;

        const text = String(value).trim();
        const dateOnlyMatched = text.match(/^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/);
        if (dateOnlyMatched) {
            const year = Number(dateOnlyMatched[1]);
            const month = Number(dateOnlyMatched[2]) - 1;
            const day = Number(dateOnlyMatched[3]);
            const parsed = new Date(year, month, day);
            return isNaN(parsed.getTime()) ? null : parsed;
        }

        const normalized = text.includes("T") ? text : text.replace(" ", "T");
        const date = new Date(normalized);
        if (!isNaN(date.getTime())) return date;

        const matched = text.match(/(\d{4})[-./](\d{1,2})[-./](\d{1,2})/);
        if (!matched) return null;

        const year = Number(matched[1]);
        const month = Number(matched[2]) - 1;
        const day = Number(matched[3]);
        const parsed = new Date(year, month, day);
        return isNaN(parsed.getTime()) ? null : parsed;
    }

    private dateKey(date: Date) {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const day = `${date.getDate()}`.padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    private setSelectedDate(date: Date) {
        const selected = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        this.selectedDateKey = this.dateKey(selected);
        this.calendarYear = selected.getFullYear();
        this.calendarMonth = selected.getMonth() + 1;
        this.selectedDateLabel = `${selected.getFullYear()}년 ${selected.getMonth() + 1}월 ${selected.getDate()}일 (${this.weekdays[selected.getDay()]})`;
        this.syncSelectedDay();
    }

    private syncSelectedDay() {
        if (!this.selectedDateKey) {
            this.selectedDayItems = [];
            return;
        }
        const selected = this.parseDate(this.selectedDateKey);
        this.selectedDayItems = selected ? this.itemsForDate(selected) : [];
    }

    private itemsForDate(date: Date) {
        const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

        return this.list
            .filter((item: any) => {
                const start = item.scheduleDate as Date;
                const end = (item.scheduleEndDate || start) as Date;
                return start.getTime() <= endOfDay.getTime() && end.getTime() >= startOfDay.getTime();
            })
            .map((item: any) => ({
                ...item,
                occurrenceDateKey: this.dateKey(date),
                occurrenceTimeLabel: this.formatOccurrenceTime(item, date)
            }));
    }

    private closeSidePanelState() {
        this.sidePanelOpen = false;
        this.panelTriggerKey = "";
    }

    private revealSidePanelOnMobile() {
        if (typeof window === "undefined" || window.innerWidth > 900) return;
        window.setTimeout(() => {
            document.querySelector(".schedule-side-panel")?.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    }

    private formatOccurrenceTime(item: any, date: Date) {
        if (item.all_day) return "종일";
        const start = item.scheduleDate as Date;
        const end = (item.scheduleEndDate || start) as Date;
        const startsToday = this.dateKey(start) === this.dateKey(date);
        const endsToday = this.dateKey(end) === this.dateKey(date);
        const startTime = this.formatScheduleTime(start);
        const endTime = this.formatScheduleTime(end);

        if (startsToday && endsToday) {
            if (start.getTime() === end.getTime()) return startTime;
            if (startTime && endTime) return `${startTime}~${endTime}`;
            return startTime || endTime;
        }
        if (startsToday) return startTime;
        if (endsToday) return endTime;
        return "";
    }

    private formatScheduleRange(start: Date, end: Date) {
        if (!end || start.getTime() === end.getTime()) {
            return this.formatScheduleFullDate(start);
        }

        if (this.dateKey(start) === this.dateKey(end)) {
            const dateLabel = `${start.getFullYear()}년 ${start.getMonth() + 1}월 ${start.getDate()}일 (${this.weekdays[start.getDay()]})`;
            const startTime = this.formatScheduleTime(start);
            const endTime = this.formatScheduleTime(end);
            if (startTime && endTime) return `${dateLabel} ${startTime} ~ ${endTime}`;
            return dateLabel;
        }

        return `${this.formatScheduleFullDate(start)} ~ ${this.formatScheduleFullDate(end)}`;
    }

    private formatAllDayScheduleRange(start: Date, end: Date) {
        const startLabel = this.formatScheduleDateOnly(start);
        const endLabel = this.formatScheduleDateOnly(end || start);
        return this.dateKey(start) === this.dateKey(end || start)
            ? `${startLabel} · 종일`
            : `${startLabel} ~ ${endLabel} · 종일`;
    }

    private formatScheduleDateOnly(date: Date) {
        return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 (${this.weekdays[date.getDay()]})`;
    }

    private formatScheduleFullDate(date: Date) {
        const dateLabel = `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 (${this.weekdays[date.getDay()]})`;
        const timeLabel = this.formatScheduleTime(date);
        return timeLabel ? `${dateLabel} ${timeLabel}` : dateLabel;
    }

    private formatScheduleTime(date: Date) {
        const hours = `${date.getHours()}`.padStart(2, "0");
        const minutes = `${date.getMinutes()}`.padStart(2, "0");
        if (hours === "00" && minutes === "00") return "";
        return `${hours}:${minutes}`;
    }

    private dateOnly(date: Date) {
        if (!(date instanceof Date) || isNaN(date.getTime())) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    private dayDistance(start: Date, end: Date) {
        const startUtc = Date.UTC(
            start.getFullYear(), start.getMonth(), start.getDate()
        );
        const endUtc = Date.UTC(
            end.getFullYear(), end.getMonth(), end.getDate()
        );
        return Math.round((endUtc - startUtc) / 86400000);
    }

    private shiftScheduleDateValue(value: any, dayOffset: number) {
        const date = this.parseDate(value);
        if (!date) return '';
        date.setDate(date.getDate() + dayOffset);
        return this.toDateTimeInput(date);
    }

    private calendarWeekDropDay(week: any, event: DragEvent) {
        const element = event.currentTarget as HTMLElement | null;
        const days = week?.days || [];
        if (!element || days.length !== 7) return null;
        const rect = element.getBoundingClientRect();
        if (!rect.width) return null;
        const relativeX = Math.max(
            0,
            Math.min(rect.width - 1, event.clientX - rect.left)
        );
        const index = Math.min(
            6, Math.floor(relativeX / (rect.width / 7))
        );
        return days[index] || null;
    }

    private refreshYearOptions(focusYear: number) {
        const start = focusYear - 10;
        const next = Array.from({ length: 21 }, (_, index) => start + index);
        if (this.yearOptions.length === next.length
            && this.yearOptions[0] === next[0]) return;
        this.yearOptions = next;
    }

    private emptyPersonalSchedule(date?: Date) {
        const selected = date || this.parseDate(this.selectedDateKey) || new Date();
        const todayKey = this.dateKey(new Date());
        const start = new Date(selected.getFullYear(), selected.getMonth(), selected.getDate(), 9, 0, 0, 0);
        if (this.dateKey(selected) === todayKey) {
            const now = new Date();
            start.setHours(now.getHours() + 1, 0, 0, 0);
        }
        const end = new Date(start.getTime() + 60 * 60 * 1000);
        const recurrenceEnd = new Date(start);
        recurrenceEnd.setMonth(recurrenceEnd.getMonth() + 1);
        return {
            title: "",
            schedule_at: this.toDateTimeInput(start),
            schedule_end_at: this.toDateTimeInput(end),
            place: "",
            description: "",
            recurrence_id: '',
            recurrence_frequency: 'none',
            recurrence_interval: 1,
            recurrence_weekdays: [this.mondayWeekday(start)],
            recurrence_end_type: 'count',
            recurrence_end_date: this.dateKey(recurrenceEnd),
            recurrence_count: 10,
            edit_scope: 'this',
            reminder_enabled: false,
            reminders: [this.reminderDraft(30)]
        };
    }

    private mondayWeekday(date: Date) {
        return (date.getDay() + 6) % 7;
    }

    private reminderDraft(minutes: any) {
        const numeric = Math.max(1, Number(minutes) || 30);
        const preset = [10, 30, 60, 1440].includes(numeric)
            ? String(numeric) : 'custom';
        return { preset, custom_minutes: numeric };
    }

    private personalSchedulePayload(forceSave: boolean) {
        const frequency = this.personalData.recurrence_frequency || 'none';
        const recurrenceRule: any = { frequency };
        if (frequency !== 'none') {
            recurrenceRule.interval = Math.max(
                1, Number(this.personalData.recurrence_interval) || 1
            );
            recurrenceRule.weekdays = [
                ...(this.personalData.recurrence_weekdays || [])
            ];
            recurrenceRule.end_type = this.personalData.recurrence_end_type || 'count';
            if (recurrenceRule.end_type === 'date') {
                recurrenceRule.end_date = this.personalData.recurrence_end_date;
            } else {
                recurrenceRule.count = Math.max(
                    2, Number(this.personalData.recurrence_count) || 2
                );
            }
        }
        const reminders = this.personalData.reminder_enabled
            ? (this.personalData.reminders || []).map((item: any) => ({
                minutes: item.preset === 'custom'
                    ? Math.max(1, Number(item.custom_minutes) || 1)
                    : Number(item.preset)
            }))
            : [];
        return {
            title: this.personalData.title,
            schedule_at: this.personalData.schedule_at,
            schedule_end_at: this.personalData.schedule_end_at,
            place: this.personalData.place,
            description: this.personalData.description,
            recurrence_rule: JSON.stringify(recurrenceRule),
            reminder_enabled: !!this.personalData.reminder_enabled,
            reminders: JSON.stringify(reminders),
            edit_scope: this.personalData.edit_scope || 'this',
            force_save: forceSave
        };
    }

    private scheduleConflictMessage(data: any) {
        const conflicts = Array.isArray(data?.conflicts) ? data.conflicts : [];
        const lines = conflicts.slice(0, 5).map((item: any) => {
            const start = this.parseDate(item.schedule_at);
            const end = this.parseDate(item.schedule_end_at);
            const occurrence = this.parseDate(item.occurrence_at);
            const existingLabel = start
                ? `${start.getMonth() + 1}/${start.getDate()} ${this.formatScheduleTime(start)}`
                : String(item.schedule_at || '');
            const endLabel = end && start && end.getTime() > start.getTime()
                ? `~${this.formatScheduleTime(end)}` : '';
            const occurrenceLabel = occurrence
                ? `${occurrence.getMonth() + 1}/${occurrence.getDate()} 발생`
                : '해당 일정';
            const category = item.meeting_name
                ? ` · ${item.meeting_name}` : '';
            const type = item.overlap_type === 'full' ? '완전 겹침' : '일부 겹침';
            return `• ${occurrenceLabel} ↔ ${existingLabel}${endLabel} `
                + `${item.title || '일정'}${category} (${type})`;
        });
        const more = conflicts.length > 5 ? `\n외 ${conflicts.length - 5}건` : '';
        return `겹치는 일정이 있습니다.\n\n${lines.join('\n')}${more}\n\n그래도 저장할까요?`;
    }

    private emptyPersonalMemory() {
        return {
            review: "",
            photos: []
        };
    }

    private emptyMeetingMemory() {
        return {
            review: '',
            photos: [],
            visibility: 'participants'
        };
    }

    private emptyExpense() {
        return {
            title: '',
            amount: '',
            payer_id: '',
            participant_ids: []
        };
    }

    private emptyPaymentInfo() {
        return {
            bank_name: '',
            account_number: ''
        };
    }

    private normalizePaymentAftercare(data: any) {
        if (!data || !Array.isArray(data.payment_infos)) return data;
        const paymentInfos: any[] = [];
        for (const info of data.payment_infos) {
            const bundled = this.parsePaymentBundle(info?.content);
            if (!bundled.length) {
                paymentInfos.push({
                    ...info,
                    storage_id: info.storage_id || info.id
                });
                continue;
            }
            for (const account of bundled) {
                paymentInfos.push({
                    ...info,
                    id: `${info.id}:${account.id}`,
                    storage_id: info.id,
                    bundle_entry_id: account.id,
                    bank_name: account.bank_name,
                    account_number: account.account_number,
                    formatted_account_number: this.formatPaymentAccountNumber(
                        account.account_number, account.bank_name
                    ),
                    content: `${account.bank_name} ${this.formatPaymentAccountNumber(
                        account.account_number, account.bank_name
                    )}`,
                    is_bundle_entry: true,
                    is_legacy: false
                });
            }
        }
        data.payment_infos = paymentInfos;
        data.my_payment_info = paymentInfos.find(
            (info: any) => info.is_mine
        ) || null;
        return data;
    }

    private applyPersonalMemory(data: any) {
        this.personalMemory = data?.memory || null;
        this.personalMemories = data?.memories || [];
    }

    private applyEventAftercare(data: any) {
        this.eventAftercare = this.normalizePaymentAftercare(data) || null;
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentBankSearch = '';
        this.paymentBankDropdownOpen = false;
        this.setDefaultExpensePayer();
    }

    private setDefaultExpensePayer() {
        if (!this.eventAftercare?.is_participant) return;
        const currentUserId = this.service.auth?.session?.id || '';
        const participants = this.eventAftercare.participants || [];
        const hasValidPayer = this.expenseDraft.payer_id && participants.some(
            (participant: any) => participant.user_id === this.expenseDraft.payer_id
        );
        if (!hasValidPayer) {
            this.expenseDraft.payer_id = participants.some(
                (participant: any) => participant.user_id === currentUserId
            ) ? currentUserId : (participants[0]?.user_id || '');
        }
        if (!this.expenseDraft.participant_ids?.length) {
            this.expenseDraft.participant_ids = participants.map(
                (participant: any) => participant.user_id
            );
        }
    }

    private async addMemoryPhotos(
        files: File[],
        target: 'personal' | 'meeting'
    ) {
        if (!files.length || this.saving) return;
        const draft = target === 'personal'
            ? this.personalMemoryDraft
            : this.meetingMemoryDraft;
        const remaining = Math.max(0, 4 - draft.photos.length);
        if (remaining === 0) {
            await this.service.modal.error('사진은 최대 4장까지 올릴 수 있습니다.');
            return;
        }
        const imageFiles = files.filter(
            (file: File) => String(file.type || '').startsWith('image/')
        );
        for (const file of imageFiles.slice(0, remaining)) {
            try {
                const image = await this.resizeMemoryPhoto(file);
                if (image.length > 1800000) {
                    await this.service.modal.error(
                        `${file.name} 파일이 너무 큽니다. 다른 사진을 선택해주세요.`
                    );
                    continue;
                }
                draft.photos.push(image);
            } catch (error) {
                await this.service.modal.error(
                    `${file.name} 사진을 불러오지 못했습니다.`
                );
            }
        }
        if (imageFiles.length < files.length) {
            await this.service.modal.error('이미지 파일만 올릴 수 있습니다.');
        } else if (imageFiles.length > remaining) {
            await this.service.modal.error('사진은 최대 4장까지 올릴 수 있습니다.');
        }
        await this.service.render();
    }

    private resizeMemoryPhoto(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(new Error('read_failed'));
            reader.onload = () => {
                const image = new Image();
                image.onerror = () => reject(new Error('decode_failed'));
                image.onload = () => {
                    const maxSize = 960;
                    const scale = Math.min(
                        1,
                        maxSize / Math.max(image.width, image.height)
                    );
                    const width = Math.max(1, Math.round(image.width * scale));
                    const height = Math.max(1, Math.round(image.height * scale));
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const context = canvas.getContext('2d');
                    if (!context) {
                        reject(new Error('canvas_failed'));
                        return;
                    }
                    context.fillStyle = '#ffffff';
                    context.fillRect(0, 0, width, height);
                    context.drawImage(image, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', 0.78));
                };
                image.src = String(reader.result || '');
            };
            reader.readAsDataURL(file);
        });
    }

    private syncSelectedEventMemoryPreview(memories: any[]) {
        if (!this.selectedEvent) return;
        const previewMemory = (memories || []).find(
            (memory: any) => (memory.photos || []).length > 0
        );
        const patch = {
            memory_count: (memories || []).length,
            memory_preview: previewMemory?.photos?.[0] || ''
        };
        Object.assign(this.selectedEvent, patch);
        const item = this.list.find(
            (schedule: any) => schedule.id === this.selectedEvent.id
        );
        if (item) Object.assign(item, patch);
        this.buildCalendar();
    }

    private toDateTimeInput(date: Date) {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const day = `${date.getDate()}`.padStart(2, "0");
        const hours = `${date.getHours()}`.padStart(2, "0");
        const minutes = `${date.getMinutes()}`.padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    private async writeClipboard(value: string) {
        const nav: any = navigator;
        if (nav.clipboard?.writeText) {
            await nav.clipboard.writeText(value);
            return;
        }
        const input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        let copied = false;
        try {
            input.focus();
            input.select();
            copied = document.execCommand('copy');
        } finally {
            input.remove();
        }
        if (!copied) throw new Error('clipboard unavailable');
    }

    private async showPaymentToast(message: string) {
        if (this.paymentToastTimer) clearTimeout(this.paymentToastTimer);
        this.paymentToastMessage = message;
        await this.service.render();
        this.paymentToastTimer = setTimeout(async () => {
            this.paymentToastMessage = '';
            this.paymentToastTimer = null;
            await this.service.render();
        }, 2200);
    }

    private errorMessage(data: any, fallback: string) {
        if (typeof data === "string" && data) return data;
        if (data && typeof data.message === "string") return data.message;
        return fallback;
    }
}

export default PortalPostListComponent;